/*!
=========================================================
* 見積登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardHeader, CardTitle,
  Table, Row, Col, Container,
  Modal, ModalBody, ModalFooter,Input,
} from "reactstrap";

import _, { forEach, reject } from 'underscore';

import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputRadio from '../FormParts/InputRadio'
import InputCheckBox from '../FormParts/InputCheckBox'
import InputDatetime from '../FormParts/InputDatetime'
import InputNumber from '../FormParts/InputNumber'
import Request from '../../common/Request';
import FormatCode from '../../common/FormatCode';
import Images from '../ViewParts/Images';
import {
  cst_prefecture,
  cst_parking_parallel_type,
  cst_tax_in_flag,
  cst_pay_unit_type_day,
  cst_pay_unit_type_month,
  cst_commission_type,
  cst_fraction_amt_flag,
  cst_term_month_flag,
  cst_survey_capacity_qty_type,
  cst_cannot_extention_flag,
  cst_auto_order_execution_flag,
  REQUEST_BOX_STATUS
} from '../../variables/codes_map';
import queryString from 'query-string';
import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';
import Format from '../../common/Format'
import { GetMessage, GetMessageWithParam, getErrorCodes } from '../../variables/message';
import format_url from '../../variables/format_url';
import GoogleDrive from  "../../common/GoogleDrive"
import custom_report from "../../variables/custom_report"
import GsuiteAuth from '../../components/Auth/GsuiteAuth'
import StaticMap from '../../common/StaticMap'
import OptionConvert from '../../common/OptionConvert';
import DetailMap from '../RouteMap/DetailMapZenrin'
import {getIcon, aryAlphabet} from "../../variables/maps"
import { googleMapKey } from "../../variables/apikeys";
import AddMemoPopup from "../ViewParts/AddMemoPopup";
import InputInvoice from "../ViewParts/InputInvoice";

const moment = require("moment");
var domain = "";

class List extends React.Component {
  constructor(props) {
    super(props);

    const castState = this.props.location.state? this.props.location.state: {}
  
//    console.log(castState,this.props.location.state.parking)

    this.state = {
      singleData:{
        values:{
          survey_parking_parallel_type : cst_parking_parallel_type[0].default,
          survey_pay_unit_type_day : cst_pay_unit_type_day[0].default,
          survey_pay_unit_type_month : cst_pay_unit_type_month[0].default,
          survey_capacity_qty_type : cst_survey_capacity_qty_type[0].default,
          survey_term_month_flag : cst_term_month_flag[0].default,
          survey_cost_commission_type : cst_commission_type[0].default,
          survey_fraction_amt_flag : cst_fraction_amt_flag[0].default,
          survey_tax_in_flag : cst_tax_in_flag[0].default,
          ignore_error : 0,
          no_send_fax : false
        },
        errors:{},
        requiredData:{}
      },
      error:{},
      
      regist_modal: false,
      sub_regist_modal: false,
      pdf_regist_modal: false,
      mapParams:[],
      dataList: [],
      error_modal: false,
      update_modal: false,
      view: false,
      valid: true,
      data: [],
      current_ulid:"",
      next_ulid:undefined,
      mapLocation:[],
//      ESTIMATE__survey_route_picture_url:'',
      travelDistance:'',
      travelDuration:'',
      requestUlid:'',
      request_data:{},
      cu_file:{},
      landmark_user : [],
      survey_data: {
        values:{
          web_survey_account : null,
          onsite_survey_account : null,
          survey_estimate_status : 1
        },
        errors:{},
        requiredData:{}
      },
      // #1034 FAX、メール送信設定追加
      notification: {
        undefined_email : false, // 送信先メールアドレス設定フラグ NULLの場合、メールの送信不可
        subcon_undefined_email : false, // 送信先メールアドレス設定フラグ NULLの場合、メールの送信不可
        send_setting:false,
        subcon_send_setting:false,
        values: {
          guide_type: 0,
          subcon_guide_type: 0,
          cc_email: "",
          fax:"",
          subcon_cc_email: "",
          subcon_fax:"",
        },
        errors: {},
        requiredData:{}
        },
      isnull_value : {
        mail: false,
        fax: false,
        subcon_mail: false,
        subcon_fax:false,
        subcon_undefined_data:false
      },
      doneEstimate : [],
      
      copyRouteMapFlag : "copyRouteMap" in castState? true : false,
      flaggedParkings : "flagged_parkings" in castState?this.props.location.state.flagged_parkings: [],
      mapObjects : "map_objects" in castState? this.props.location.state.map_objects: null,
      parkings : "parking" in castState? this.props.location.state.parking: [],
      syncMapParamters : false,
      addMemoPopupData:{},//メモPOPUP用
      Pdf01final:undefined,
      Pdf02final:undefined,
      pdf_created:false,
      pdf_registed:false,
      estimate_regist_flg:false,
    };

    this.customerUseCustomizedEstimate = custom_report.estimate.survey["アイダ設計"].customer_natural_id // アイダ設計
    this.customerUseCustomizedEstimateForTouken = custom_report.estimate.survey["東建コーポレーション"].customer_natural_id // 東建コーポレーション
    this.customerUseCustomizedEstimateForTaiseiHousing = custom_report.estimate.survey["大成建設ハウジング"].customer_natural_id // 大成建設ハウジング
    this.customerUseCustomizedEstimateForTaiseiHousingBranch = custom_report.estimate.survey["大成建設ハウジング"].customer_branch_natural_id // 大成建設ハウジング 東海・九州
    this.customerUseCustomizedEstimateForTaiseiHousingBranch2 = custom_report.estimate.survey["大成建設ハウジング"].customer_branch_natural_id_2 // 大成建設ハウジング 近畿


    this.images = React.createRef();
    this.supplier_select_popup = React.createRef();
    this.pageDiv = React.createRef();
    
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleUpdateModal = this.toggleUpdateModal.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.togglePdfRegistModal = this.togglePdfRegistModal.bind(this);

    this.pdfCreateReqest = this.pdfCreateReqest.bind(this);
    this.pdfCreate = this.pdfCreate.bind(this);
    this.regEstimateData = this.regEstimateData.bind(this);

    this.regist = this.regist.bind(this)

    this.copyMaster = this.copyMaster.bind(this);
    this.bingmap = React.createRef();
    this.bingmapCopy = React.createRef();

    this.getEstimatePDF = this.getEstimatePDF.bind(this)
    this.validateCallback = this.validateCallback.bind(this)
    this.validateSurveyCallback = this.validateSurveyCallback.bind(this)
    this.validateAutoOrderCallback = this.validateAutoOrderCallback.bind(this)
    this.getCountsFromDuration = this.getCountsFromDuration.bind(this)
    this.uploadImageCallback = this.uploadImageCallback.bind(this)
    this.requestEstimatePDF = this.requestEstimatePDF.bind(this)
    this.requestEstimateMapPDF = this.requestEstimateMapPDF.bind(this)
    this.createEstimateDetails = this.createEstimateDetails.bind(this)
    this.mapGestureHandle = this.mapGestureHandle.bind(this)
    this.createRouteMaps = this.createRouteMaps.bind(this)
    this.define_subtotal = this.define_subtotal.bind(this)

    // 見積書確認処理
    this.onClickedConfirmEstimates = this.onClickedConfirmEstimates.bind(this)
    // 見積書送付処理
    this.onClickedSendEstimates = this.onClickedSendEstimates.bind(this)
    //　見積情報作成処理→ コピー処理及び見積作成処理スキップ対応
    this.validateEstimateDetails = this.validateEstimateDetails.bind(this)

    let query_params = queryString.parse(this.props.location.search);
    if (query_params && query_params.ulid) {
      this.state.data = Array.isArray(query_params.ulid)?query_params.ulid.reduce((objectsSet, singleUlid)=>{
        objectsSet[singleUlid]={}
        return objectsSet
      },{}):{[query_params.ulid]:{}}
    }
    this.state.requestUlid = query_params.request_ulid

    // #1034 
    this.renderSendSetting = this.renderSendSetting.bind(this);
    this.validateSendContact = this.validateSendContact.bind(this);
    this.guide_type = this.guide_type.bind(this) // #1034 元請送信設定 0:未送信 1:両方 2:メール 3:ファックス
    this.subcon_guide_type = this.subcon_guide_type.bind(this) // #1034 下請送信設定 0:未送信 1:両方 2:メール 3:ファックス
    this.validNotificateStatus = this.validNotificateStatus.bind(this)
    // 仕入先メモ顧客メモPOPUP用
    this.addMemoPopup = React.createRef()
    this.memoPopupAction= this.memoPopupAction.bind(this)
  }
  // #1034 案内設定
  guide_status ( type ) {
    const guide_param = {
      unsent: 0,
      send_mail_and_fax: 1,
      send_mail: 2,
      send_fax : 3
    }
    return guide_param[type];
  }
  // #1034 元請送信設定
  guide_type (destination_type, guide_type) {
    var send_type = "";
    switch (destination_type) {
      case 0: case 2:{
        switch (guide_type) {
          case 0:{send_type = "send_mail_and_fax";}break;
          case 1:{send_type = "send_mail";}break;
          case 2:{send_type = "send_fax";}break;
        }
      }break;
      case 1:{send_type = "unsent";}break;
    }
    return this.guide_status(send_type);
  }
  // #1034 下請送信設定
  subcon_guide_type (destination_type, guide_type) {
    var send_type = "";
    switch (destination_type) {
      case 1: case 2:{
        switch (guide_type) {
          case 0:{send_type = "send_mail_and_fax";}break;
          case 1:{send_type = "send_mail";}break;
          case 2:{send_type = "send_fax";}break;
        }
      }break;
      case 0:{send_type = "unsent";}break;
    }
    return this.guide_status(send_type);
  }

  // 見積もり編集判定(urlにeditが含まれている)
  isEdit(){
    return window.location.pathname.includes('/edit')
  }
  // 経路図編集を行ったか？(urlにeditが含まれている)
  isRouteEdit(){
    return window.location.pathname.includes('previous=route_edit')
  }

  isMapZoom(){
    return this.isEdit() && this.isRouteEdit()
  }

  // 初期ロード用
  async componentDidMount() {

//    console.log(this.props.location.state);
//    console.log(this.state.mapObjects)
    try{
    /*　ここは開発者が記述　*/
    const {
      data,
      requestUlid
    } = this.state
    const requestData = await new Promise((resolve,reject)=>{
    Request.get('/api/request/' + requestUlid, {},
      res => resolve(res.data), ()=>reject())
    })
    if (!requestData){
      this.props.pageChangeAlert.current.inactivate();
      this.props.history.push('/forbidden')
      return
    }
    if(this.props.data_view_flag==2 && (requestData.user_branch_id != GsuiteAuth.get('user_branch_id'))){
      this.props.pageChangeAlert.current.inactivate()
      this.props.history.push('/forbidden')
      return
    } else if (this.props.data_view_flag==3 && (requestData.onsite_survey_account != GsuiteAuth.get('id') && requestData.web_survey_account != GsuiteAuth.get('id'))) {
      this.props.pageChangeAlert.current.inactivate()
      this.props.history.push('/forbidden')
      return
    } else if(requestData.survey_status==1 && this.props.data_view_flag==3 && (requestData.user_branch_id != GsuiteAuth.get('user_branch_id'))){
      this.props.pageChangeAlert.current.inactivate()
      this.props.history.push('/forbidden')
      return
    } else if(requestData.survey_status==2 && this.props.data_view_flag==3 && requestData.onsite_survey_account != GsuiteAuth.get('id')){
      this.props.pageChangeAlert.current.inactivate()
      this.props.history.push('/forbidden')
      return
    }
    // 見積送付済み
    if (requestData.request_box_status ==  REQUEST_BOX_STATUS.COMPLETE){ 
      this.props.pageChangeAlert.current.inactivate();
      this.props.alertModal.current.confirmCheck({messageNo:2443},()=>{
        this.props.history.push('/construction/list')
      },false);
    }

    // 固定表示データ
    const {
      customer_system_memo,
      customer_branch_system_memo,
      customer_user_system_memo,
      customer_other_request,
    } = requestData

    const estimate_expire_date = await new Promise((resolve)=>{
      Request.get('/api/workday', { add_day : 14 }, res => {
        resolve(moment(res.data).format("YYYY-MM-DDT00:00:00"))
      })
    })

    
    Request.get("/api/landmark/lastupdate",{}, res => {
      // const user_list = OptionConvert.optionsById(res.Data)
      const user_list = res.Data.map((user) => ({
        value : user.id,
        label : user.name,
        tel : user.user_tel,
      }));
      this.setState({landmark_user:user_list});
    })

//    await StaticMap.googleMapScript()
    const newData = Object.keys(data).map(( dataKey )=>{
      const url = domain + '/api/request/parking/initialize/'+dataKey;
      return (async()=>{
        const requestParking = await new Promise((resolve,reject)=>{
          Request.get(url, {
            join_with:'supplier__customer_branch'
          }, res => {
            // const parking = this.state.parkings.find((p)=>p.request_parking_ulid == dataKey)
            const {direction} = this.props.location.state.parking.find((p)=>p.request_parking_ulid == dataKey) || {}
            // console.log(direction)
            if(direction != undefined && direction.distance != undefined){
              const {site_distance_meter, site_distance_minute} = direction.distance
              if (site_distance_meter && site_distance_minute) {
                // 距離・時間はパラメータ受け取りの再計算済みのもので上書き
                // console.log('update site_distance_meter old: ' + res.data['site_distance_meter'] + ' new: ' + parking['site_distance_meter'])
                res.data['site_distance_meter'] = site_distance_meter
                res.data['site_distance_minute'] = site_distance_minute
              }
            }
            // console.log(res.data)
            resolve(res.data)
          }, ()=>reject())
        })
        // console.log(requestParking['site_distance_meter'],requestParking['site_distance_minute'])


        let extend_target_estimate
        if (!this.isEdit()) {
          // 新規でコピーフラグがある場合は、orderの情報を表示する
          extend_target_estimate = (requestParking.extend_estimate_natural_id) ? await new Promise((resolve,reject)=>{
            Request.get('/api/order', {
              estimate_natural_id: requestParking.extend_estimate_natural_id,
              copy_extention_flag:1
            }, res => {
              resolve(res.Data[0])
            }, ()=>reject())
          }) : undefined
        } else {
          // 見積編集の場合,estimateの情報を表示する
          extend_target_estimate = await new Promise((resolve,reject)=>{
            // 編集中の見積もり取得
            Request.get('/api/estimate', {
              id: requestParking.estimate
            }, res => {
              resolve(res.Data[0])
            }, ()=>reject())
          })
        }

        const {
          parking,
          request,
          customer_system_use_flag,
        } = requestParking
        
        console.log(newData);

        const project = request.project
        const supplier = parking.supplier
        const customer_branch = project.customer_user.customer_branch

        // #1034 メール、ファックス送信フォームの開発
        const subcontract_customer_branch = (project.subcontract_customer_branch_natural_id)? await new Promise((resolve, reject)=>{
          Request.get("/api/customer/branch",{
            customer_branch_natural_id:project.subcontract_customer_branch_natural_id
          },
          res=>resolve(res.Data[0]), ()=>reject())
        }) : undefined

        // request_type
        // 初回・追加      延長         積替え用地
        // 0,1            2             3
        // --見積情報
        // 見積台数 survey_capacity_qty 
        const survey_capacity_qty = request.request_type == 2 ? extend_target_estimate.survey_capacity_qty : undefined
        //                               単位   survey_capacity_qty_type
        const survey_capacity_qty_type = request.request_type == 2 ? extend_target_estimate.survey_capacity_qty_type : cst_survey_capacity_qty_type[0].default
        // --仕入金額
        // 賃料（月単価）  賃料（月単価）             survey_cost_parking_rent
        const survey_cost_parking_rent = (request.request_type==0 || request.request_type==1 || request.request_type==3)?
          parking.cost_parking_rent : (request.request_type==2? extend_target_estimate.survey_cost_parking_rent : 0)

        // 調査見積仕入先情報：賃料支払先区分
        const survey_cost_parking_rent_payment_type = request.request_type == 2 ? extend_target_estimate.survey_cost_parking_rent_payment_type : undefined
        // 調査見積仕入先情報：賃料支払先適格請求書発行事業者区分
        const survey_cost_parking_rent_invoice_business_type = request.request_type == 2 ? extend_target_estimate.survey_cost_parking_rent_invoice_business_type : undefined
        // 調査見積仕入先情報：賃料支払先適格請求書発行事業者番号
        const survey_cost_parking_rent_invoice_registration_number = request.request_type == 2 ? extend_target_estimate.survey_cost_parking_rent_invoice_registration_number : undefined
        
        // 手数料計算方法  手数料計算方法             survey_cost_commission_type
        const survey_cost_commission_type = (request.request_type==0 || request.request_type==1 || request.request_type==3)?
          parking.commission_type : (request.request_type==2? extend_target_estimate.survey_cost_commission_type : 0)
        // 手数料                                   survey_cost_commission
        const survey_cost_commission = (request.request_type==0 || request.request_type==1 || request.request_type==3)?
          parking.cost_commission : (request.request_type==2? 0 : 0)

        // 調査見積仕入先情報：手数料支払先区分
        const survey_cost_commission_payment_type = request.request_type == 2 ? extend_target_estimate.survey_cost_commission_payment_type : undefined
        // 調査見積仕入先情報：手数料支払先適格請求書発行事業者区分
        const survey_cost_commission_invoice_business_type = request.request_type == 2 ? extend_target_estimate.survey_cost_commission_invoice_business_type : undefined
        // 調査見積仕入先情報：手数料支払先適格請求書発行事業者番号
        const survey_cost_commission_invoice_registration_number = request.request_type == 2 ? extend_target_estimate.survey_cost_commission_invoice_registration_number : undefined

        // 礼金
        const survey_cost_key_money = (request.request_type==0 || request.request_type==1 || request.request_type==3)?
          parking.cost_key_money : (request.request_type==2? 0 : 0)
        
        // 調査見積仕入先情報：礼金支払先区分
        const survey_cost_key_money_payment_type	 = request.request_type == 2 ? extend_target_estimate.survey_cost_key_money_payment_type : undefined
        // 調査見積仕入先情報：礼金支払先適格請求書発行事業者区分
        const survey_cost_key_money_invoice_business_type	 = request.request_type == 2 ? extend_target_estimate.survey_cost_key_money_invoice_business_type : undefined
        // 調査見積仕入先情報：礼金支払先適格請求書発行事業者番号
        const survey_cost_key_money_invoice_registration_number	 = request.request_type == 2 ? extend_target_estimate.survey_cost_key_money_invoice_registration_number : undefined

        // その他
        const survey_cost_other = 0

        // 調査見積仕入先情報：その他支払先区分
        const survey_cost_other_payment_type = request.request_type == 2 ? extend_target_estimate.survey_cost_other_payment_type : undefined  
        // 調査見積仕入先情報：その他支払先適格請求書発行事業者区分
        const survey_cost_other_invoice_business_type = request.request_type == 2 ? extend_target_estimate.survey_cost_other_invoice_business_type : undefined
        // 調査見積仕入先情報：その他支払先適格請求書発行事業者番号
        const survey_cost_other_invoice_registration_number = request.request_type == 2 ? extend_target_estimate.survey_cost_other_invoice_registration_number : undefined

        // 課税項目名
        const estimate_detail_name = request.request_type == 2 ? extend_target_estimate.estimate_detail_name : undefined
        // 課税金額
        const estimate_detail_amt = request.request_type == 2 ? extend_target_estimate.estimate_detail_amt : undefined
        // 非課税項目名
        const estimate_detail_name_ex = request.request_type == 2 ? extend_target_estimate.estimate_detail_name_ex : undefined
        // 非課税金額
        const estimate_detail_amt_ex = request.request_type == 2 ? extend_target_estimate.estimate_detail_amt_ex : undefined

        //                               仕入合計   ___CAL_cost_total_amt
        const _CAL_cost_total_amt = 0 //calculation
        // --見積金額
        // 敷金
        const survey_cost_security_deposit = (request.request_type==0 || request.request_type==1 || request.request_type==3)
          ? parking.cost_security_deposit : 0
        // 賃料（月単価）  賃料（月単価）           survey_parking_rent
        const survey_parking_rent = 
            (request.request_type==0 || request.request_type==1 || request.request_type==3)
            ? customer_branch.additional_amt == null ? "" :parking.cost_parking_rent + customer_branch.additional_amt
            : (
                request.request_type==2 
                ? customer_branch.additional_amt == null ? "" : extend_target_estimate.survey_parking_rent
                : 0
              )
        // 上乗せ額：賃料（月単価）                  ___CAL_parking_rent_profit ?? survey_parking_rent_profit ??
        const survey_parking_rent_profit = (request.request_type==0 || request.request_type==1 || request.request_type==3)
          ?  survey_parking_rent === "" ? "" : customer_branch.additional_amt : (request.request_type==2? extend_target_estimate.survey_parking_rent - extend_target_estimate.survey_cost_parking_rent : 0)


        // 手数料割引率（%）                        survey_commission_discount_rate
        const survey_commission_discount_rate = (request.request_type==0 || request.request_type==1 || request.request_type==3)
          ? customer_branch.discount_rate : 0
        // 礼金                                     survey_key_money
        const survey_key_money = (request.request_type==0 || request.request_type==1 || request.request_type==3) ? 
          customer_branch.additional_amt == null ? "" 
          : (parking.cost_key_money > 0 && customer_branch.additional_amt > 0) ? 
            customer_branch.additional_amt + parking.cost_key_money
          : 0 
        : 0 

        // 値引額                                 survey_discount_amt
        const survey_discount_amt = (request.request_type==0 || request.request_type==1 || request.request_type==3)
          ? customer_branch.discount_amt : 0
        // 端数調整                                survey_fraction_amt_flag
        const survey_fraction_amt_flag = (request.request_type==0 || request.request_type==1 || request.request_type==3)
          ? customer_branch.fraction_amt_flag : 1
        // 税              税            税       survey_tax_in_flag
        const survey_tax_in_flag = request.request_type==2
          ? extend_target_estimate.survey_tax_in_flag 
          : customer_branch.tax_in_flag
        // 手数料           手数料

        const extend_target_survey_commission = extend_target_estimate && extend_target_estimate.survey_commission != undefined ? extend_target_estimate.survey_commission : ""

        const survey_commission = 
              (request.request_type==2) 
              ? customer_branch.additional_amt == null ? "" : survey_parking_rent * 0.1 
                : (customer_branch.additional_amt == null ? "" : extend_target_survey_commission ? extend_target_survey_commission : survey_parking_rent)

        console.log(survey_commission)
        const requestName = (request.request_type==0)?""
        :`（${request.request_type==1
          ?'追加':(request.request_type==2
            ?'延長':(request.request_type==3)
            ?'積替用地'
            :"")}）`
        const site_name = `${project.site_name}`

        const survey_parking_name = parking.parking_name + requestName

        const {
          subcontract_customer_id,
          subcontract_customer_natural_id,
          subcontract_customer_branch_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user : subcontract_customer_user_id,
          subcontract_customer_user_natural_id,
        } = project

        const {
          customer_branch_cc_email,
          customer_branch_fax,
          responsible_user_id,
        } = customer_branch

        const {
          customer_user_email
        } = project.customer_user

        // 保存ずみのデータで更新する
        const param_parking_found = this.state.parkings.find((p)=>p.request_parking_ulid == dataKey) ? true : false
        const copyEstimate = (request.estimate_copy_flag == 1 && extend_target_estimate) ? this.copyEstimate(extend_target_estimate, param_parking_found)
          : (this.isEdit() && extend_target_estimate) ? this.copyEstimate(extend_target_estimate, param_parking_found): this.setEstimateMapStateNonedata()
        // 見積コピーの場合は見積登録時に追加した駐車場写真追加
        const copyParkingPicturesSet = new Set([
          ...parking.parking_picture_filelist?parking.parking_picture_filelist.split(','):[],
          ...extend_target_estimate ? [extend_target_estimate.survey_parking_picture_url] : []
        ]);
        const copyParkingPictures = Array.from(copyParkingPicturesSet);

        return {[dataKey]:{
          parking_pictures: copyParkingPictures,
          upper_limit_additional_amt: customer_branch.upper_limit_additional_amt,
          request_type: request.request_type,
          
          request_id:request.id,
          request_natural_id:request.request_natural_id,
          project_id:project.id,
          project_natural_id:project.project_natural_id,
          customer_id:project.customer_id,
          customer_natural_id:project.customer_natural_id,
          customer_branch_id:project.customer_branch_id,
          customer_branch_natural_id:project.customer_branch_natural_id,
          customer_user_id: project.customer_user.id,
          customer_user_natural_id: project.customer_user_natural_id,
          customer_system_use_flag,
          customer_system_memo,
          customer_branch_system_memo,
          customer_user_system_memo,
          customer_other_request,
          parking_id:parking.id,
          parking_natural_id:parking.parking_natural_id,
          supplier_natural_id:supplier.supplier_natural_id,
          supplier_id:supplier.id,
          // survey_estimate_rule: customer_branch.estimate_rule,
          supplier_invoice_business_type: supplier.supplier_invoice_business_type,
          supplier_invoice_registration_number: supplier.supplier_invoice_registration_number,
          survey_capacity_flag_car: parking.capacity_flag_car,
          survey_capacity_flag_light_truck: parking.capacity_flag_light_truck,
          survey_capacity_flag_truck: parking.capacity_flag_truck,
          survey_capacity_flag_other: parking.capacity_flag_other,
          survey_parking_parallel_type: (parking.parking_parallel_type == undefined ? cst_parking_parallel_type[0].default : parking.parking_parallel_type),
          survey_pay_unit_type_day: (parking.pay_unit_type_day == undefined ? cst_pay_unit_type_day[0].default : parking.pay_unit_type_day),
//          request_natural_id: request.request_natural_id,
          site_prefecture: project.site_prefecture,
          site_city: project.site_city,
          site_address: project.site_address,
          survey_parking_picture_url: parking.parking_picture_url_thumbnail,
          survey_parking_prefecture: parking.parking_prefecture,
          survey_parking_city: parking.parking_city,
          survey_parking_address: parking.parking_address,
          survey_parking_address_contract: parking.parking_address_contract,
          survey_pay_unit_type_month: (parking.pay_unit_type_month==undefined ? cst_pay_unit_type_month[0].default : parking.pay_unit_type_month),
          
          survey_capacity_type_other: parking.capacity_car_type,
          survey_capacity_special_request: parking.capacity_special_request,
          supplier_name: supplier.supplier_name,
          supplier_name_kana: supplier.supplier_name_kana,
          supplier_tel: supplier.supplier_tel,
          supplier_tel2: supplier.supplier_tel2,
          supplier_fax: supplier.supplier_fax,
          
          survey_site_distance_minute: requestParking.site_distance_minute,
          survey_site_distance_meter: requestParking.site_distance_meter,
          
          survey_available_start_date: requestParking.request_start_date ? requestParking.request_start_date : request.want_start_date,
          survey_available_end_date:  requestParking.request_end_date ? requestParking.request_end_date : request.want_end_date ,
          survey_capacity_qty: requestParking.request_capacity_qty ? requestParking.request_capacity_qty : "",
          survey_capacity_qty_type,
          survey_cost_parking_rent,
          survey_cost_parking_rent_payment_type : survey_cost_parking_rent_payment_type,
          survey_cost_parking_rent_invoice_business_type : survey_cost_parking_rent_invoice_business_type,
          survey_cost_parking_rent_invoice_registration_number : survey_cost_parking_rent_invoice_registration_number,
          survey_cost_commission_type : (survey_cost_commission_type == undefined ? cst_commission_type[0].default : survey_cost_commission_type),
          survey_cost_commission,
          survey_cost_commission_payment_type: survey_cost_commission_payment_type,
          survey_cost_commission_invoice_business_type: survey_cost_commission_invoice_business_type,
          survey_cost_commission_invoice_registration_number: survey_cost_commission_invoice_registration_number,
          survey_cost_key_money,
          survey_cost_key_money_payment_type: survey_cost_key_money_payment_type,
          survey_cost_key_money_invoice_business_type: survey_cost_key_money_invoice_business_type,
          survey_cost_key_money_invoice_registration_number: survey_cost_key_money_invoice_registration_number,
          survey_cost_other,
          survey_cost_other_payment_type: survey_cost_other_payment_type,
          survey_cost_other_invoice_business_type: survey_cost_other_invoice_business_type,
          survey_cost_other_invoice_registration_number: survey_cost_other_invoice_registration_number,
          estimate_detail_name: estimate_detail_name,
          estimate_detail_amt: estimate_detail_amt,
          estimate_detail_name_ex: estimate_detail_name_ex,
          estimate_detail_amt_ex: estimate_detail_amt_ex,
          _CAL_cost_total_amt,
          survey_cost_security_deposit,
          survey_parking_rent,
          survey_parking_rent_profit, //_CAL_parking_rent_profit,
          survey_commission_discount_rate,
          survey_key_money,
          survey_discount_amt,
          ...{survey_tax_in_flag:survey_tax_in_flag==undefined?cst_tax_in_flag[0].default:survey_tax_in_flag},
          survey_fraction_amt_flag : (survey_fraction_amt_flag==undefined ? cst_fraction_amt_flag[0].default : survey_fraction_amt_flag),
          survey_commission,
          site_name,
          
          latitude:parking.latitude,
          longitude:parking.longitude,
          request_parking_status:requestParking.request_parking_status,
          request_parking_space_qty:requestParking.request_parking_space_qty,
          survey_parking_name,

          subcontract_customer_id,
          subcontract_customer_natural_id,
          subcontract_customer_branch_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_id,
          subcontract_customer_user_natural_id,
          ignore_error : 0,
          no_send_fax : false,
          survey_term_month_flag : copyEstimate.survey_term_month_flag != undefined ? copyEstimate.survey_term_month_flag: cst_term_month_flag[0].default,
          want_guide_type_subcontract: request.want_guide_type_subcontract,
          want_guide_type:request.want_guide_type,
          keyForRequestParking:dataKey, // 

          user_branch: project.user_branch,
          user_branch_natural_id: project.user_branch_natural_id,
          estimate_expire_date : estimate_expire_date,

          // #1034 
          customer_branch_cc_email: customer_branch_cc_email,
          customer_branch_fax: customer_branch_fax,
          subcontract_customer_branch_cc_email:(subcontract_customer_branch != undefined)?subcontract_customer_branch.customer_branch_cc_email:"",
          subcontract_customer_branch_fax:(subcontract_customer_branch != undefined)?subcontract_customer_branch.customer_branch_fax:"",
          to_email: customer_user_email,
          subcontract_customer_user:project.subcontract_customer_user_data,
          responsible_user_id, // #1328
          // #1022　copyEstimateで保存ずみの値を設定する
          ESTIMATE__survey_route_picture_url :  GoogleDrive.getDownloadUrl(copyEstimate.survey_route_picture_url),
          ESTIMATE__survey_route_zoom_picture_url : GoogleDrive.getDownloadUrl(copyEstimate.survey_route_zoom_picture_url),
          ESTIMATE__survey_route_qr_url : copyEstimate.survey_route_qr_url,
          ESTIMATE__survey_route_zoom_qr_url : copyEstimate.survey_route_zoom_qr_url,
          order_memo:"",
          supplier_memo:"",
          // ファックス番号
          request_fax: request.fax,
          ...copyEstimate,
          // 1539
          request_parking_history: {...request.parking_history},

          auto_order_display_flag: customer_branch.auto_order_display_flag
        }};
      })()
    })

    const resolved = await Promise.all(newData).then(resolve=>resolve)
    console.log(resolved)

//    console.log("sort data",Object.values(resolved),newData);

    // GoogleMapで計算された距離でソートする
    // resolved.sort((a, b) => {
    //   const a_meter = a[Object.keys(a)[0]].survey_site_distance_meter
    //   const b_meter = b[Object.keys(b)[0]].survey_site_distance_meter
    //   return a_meter - b_meter;
    // })
    const resolvedObjectForm = resolved && await resolved.reduce((acc,element)=>{
      const key = Object.keys(element)[0]
      acc[key] = element[key]
      return acc
    },{})
    const resolvedObjectFormWithMaps = await this.getMapUrls(resolvedObjectForm, requestData)

    console.log(resolvedObjectForm,resolvedObjectFormWithMaps)

//    console.log(resolvedObjectFormWithMaps)

    let resolvedObjectValues = Object.values(resolvedObjectFormWithMaps);

    const {
      to_email,
      subcontract_customer_user
    } = resolvedObjectValues[0];

    var email = [];
    var sub_email = [];
    // console.log(requestData.cc_email);
    // console.log(requestData)
    // console.log(requestData.send_destination_type)
    let is_subconstruct_to_email = false

    if (subcontract_customer_user != null) {
      is_subconstruct_to_email = (subcontract_customer_user.customer_user_email && subcontract_customer_user.customer_user_email.length > 0)
    }
    if(requestData.send_destination_type == 1){
      if (requestData.cc_email !== null && requestData.cc_email.length>0) {
        sub_email.push(requestData.cc_email)
      }
      if(resolvedObjectValues[0].subcontract_customer_branch_cc_email){
        sub_email.push(resolvedObjectValues[0].subcontract_customer_branch_cc_email)
      }

      if(requestData.estimate_copy_flag == 1){
        sub_email.push(requestData.cc_email_subcontract)
      }
    }else if (requestData.send_destination_type == 0){
      if (requestData.cc_email !== null && requestData.cc_email.length>0) {
        email.push(requestData.cc_email)
      }
      if (resolvedObjectValues[0].customer_branch_cc_email ) {
        email.push(resolvedObjectValues[0].customer_branch_cc_email)
      }
    }else{
      if (requestData.cc_email !== null && requestData.cc_email.length>0) {
        email.push(requestData.cc_email)
      }
      if (resolvedObjectValues[0].customer_branch_cc_email ) {
        email.push(resolvedObjectValues[0].customer_branch_cc_email)
      }
      if(resolvedObjectValues[0].subcontract_customer_branch_cc_email){
        sub_email.push(resolvedObjectValues[0].subcontract_customer_branch_cc_email)
      }
      if(requestData.estimate_copy_flag == 1){
        sub_email.push(requestData.cc_email_subcontract)
      }      

    }
    // console.log(sub_email)
    // console.log(is_subconstruct_to_email)
    // console.log(subcontract_customer_user)
    const notificationValues = requestData.estimate_copy_flag == 1 ? {
      // 見積コピーの場合は、前回の情報をそのまま使う
      // 送信設定データ
      guide_type: requestData.want_guide_type,
      subcon_guide_type: requestData.want_guide_type_subcontract,
      // 入力フォームデータ
      cc_email:  (email.length>0)?email.join(","):"",
      fax: requestData.fax,
      subcon_cc_email: (sub_email.length>0)?sub_email.join(","):"",
      subcon_fax: requestData.fax_subcontract,
    } : {
      // 送信設定データ
      guide_type: resolvedObjectValues[0].want_guide_type,
      subcon_guide_type: resolvedObjectValues[0].want_guide_type_subcontract,
      // 入力フォームデータ
      cc_email: (email.length>0)?email.join(","):"",
      fax: resolvedObjectValues[0].customer_branch_fax,
      // fax: resolvedObjectValues[0].request_fax,
      subcon_cc_email: (sub_email.length>0)?sub_email.join(","):"",
      subcon_fax: resolvedObjectValues[0].subcontract_customer_branch_fax,
    }

    console.log(notificationValues);

    if (this.state.mapObjects) {
      this.state.mapObjects.forEach((m)=>{
        let {directions} = m.objects
        directions.forEach((d)=>{
          resolvedObjectFormWithMaps[d.request_parking_ulid].map_param = {
            zoom : 18,
            lat : d.direction.markers.lat,
            lng : d.direction.markers.lng
          }
        })
      })
    }
    console.log(resolvedObjectFormWithMaps)
    // console.log(resolvedObjectFormWithMaps)
    this.setState({
      data:resolvedObjectFormWithMaps,
      request_data:{
        ...requestData,
        values: {
          auto_order_execution_flag: requestData.auto_order_execution_flag
        }
      },
      survey_data:{
        ...this.state.survey_data,
        values : {
          ...this.state.survey_data.values,
          web_survey_account : requestData.web_survey_account,
          onsite_survey_account : requestData.onsite_survey_account,
          // survey_estimate_status : requestData.estimate_copy_flag == 1 ? requestData.survey_estimate_status : requestData.survey_status
          survey_estimate_status : 1
        }
      },
      // #1034
      notification:{
        undefined_email: (to_email && to_email.length>0)?false :true,
        subcon_undefined_email: !is_subconstruct_to_email,
        send_setting: (requestData.send_destination_type  == 0 || requestData.send_destination_type  == 2), // 元請案内通知設定
        subcon_send_setting: (requestData.send_destination_type  == 1 || requestData.send_destination_type  == 2),　// 下請案内通知設定
        values: {
          ...this.state.notification.values,
          ...notificationValues
        },
        errors : {
          ...this.state.notification.errors,
        },
          requiredData : {
            ...this.state.notification.requiredData,
            fax : ["必須項目が未入力です"] ,
            subcon_fax : ["必須項目が未入力です"]
          
        }
      }
    }, ()=>{
//      console.log(this.state.parkings)
      let request_parking_ulid = this.state.parkings[0].request_parking_ulid
      this.setSingleDatum(request_parking_ulid,false)
      this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.request_data)
    })
    }catch(errr){
      console.log('didmount error ', errr)
      Request.setProgress(0)
      this.props.alertModal.current.confirmCheck({
        messageNo:2503,
        closeBtn: false
      },() => {
        window.location.reload()
      }, false);
      return;
    }
  }

  componentWillUnmount(){
    window.google={}
  }

  calcDistance(data){
    return new Promise(resolve => {
      const url = `/api/calcdistance?project=${data.project.latitude},${data.project.longitude}&parking=${data.parking.latitude},${data.parking.longitude}`
      // console.log(url);
      Request.get(url, {}, res => {
          // console.log(res.Data);
          let {site_distance_meter,site_distance_minute } = res.Data

          resolve({site_distance_meter, site_distance_minute})
      }
      , () => {
          this.props.alertModal.current.showErrorModal({messageNo:2477});
      }
      , undefined
      , false)
    })
  }

  validate(check_estimate_expire_date = false){

    let errors = this.state.singleData.errors

    if(!check_estimate_expire_date){
      errors = {
        ...this.state.singleData.errors,
        estimate_expire_date : undefined
      }
    }

    let message = getErrorCodes(errors, this.state.singleData.values.ignore_error)


    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  // 適格事業者番号のバリデーションチェック
  // 区分が1の場合=>適格事業者番号のバリデーションチェックを行う、エラーの場合はエラーコードを返す
  // 区分が2の場合=>""空を返す
  validateInvoiceNumber (type,number) {
    if ( type == 1) {
      if (!number)  {
      return [GetMessage(2601)]
      }
      if (!number.match(/^T\d{13}$/)) {
      return [GetMessage(2035)]
      } 
      return ""
    }
    else if ( type == 2 ) {
      return ""
    } 
  }	
  validateSupplierInvoiceNumber(values){
		let {
			supplier_invoice_business_type,
			supplier_invoice_registration_number
		} = values;
    console.log(supplier_invoice_business_type,supplier_invoice_registration_number)
		return  (supplier_invoice_business_type == null || supplier_invoice_business_type == 0 || (supplier_invoice_business_type == 1 && (supplier_invoice_registration_number == "" || supplier_invoice_registration_number == null)))
	
	}

  validateCallback(newData, callback=()=>{}){
    const singleData = this.state.singleData;
    const estimate_detail_name = newData.values.estimate_detail_name? newData.values.estimate_detail_name: ""
    const estimate_detail_amt = newData.values.estimate_detail_amt? parseInt(newData.values.estimate_detail_amt): 0
    const estimate_detail_name_ex = newData.values.estimate_detail_name_ex? newData.values.estimate_detail_name_ex: ""
    const estimate_detail_amt_ex = newData.values.estimate_detail_amt_ex? parseInt(newData.values.estimate_detail_amt_ex): 0
    let {
	  	survey_cost_parking_rent_payment_type,
	    survey_cost_parking_rent_invoice_business_type:org_survey_cost_parking_rent_invoice_business_type,
      survey_cost_parking_rent_invoice_registration_number,
      survey_cost_commission_payment_type,
      survey_cost_commission_invoice_business_type:org_survey_cost_commission_invoice_business_type,
      survey_cost_commission_invoice_registration_number,
      survey_cost_key_money_payment_type,
      survey_cost_key_money_invoice_business_type:org_survey_cost_key_money_invoice_business_type,
      survey_cost_key_money_invoice_registration_number,
      survey_cost_other_payment_type,
      survey_cost_other_invoice_business_type:org_survey_cost_other_invoice_business_type,
      survey_cost_other_invoice_registration_number,
      survey_cost_parking_rent,
      survey_cost_commission,
      survey_cost_key_money,
      survey_cost_other
    } = newData.values;
    // console.log(estimate_detail_name_ex.length,estimate_detail_amt_ex)
    let survey_cost_parking_rent_invoice_business_type = org_survey_cost_parking_rent_invoice_business_type == undefined ? 0 : org_survey_cost_parking_rent_invoice_business_type
    let survey_cost_commission_invoice_business_type = org_survey_cost_commission_invoice_business_type == undefined ? 0 : org_survey_cost_commission_invoice_business_type
    let survey_cost_key_money_invoice_business_type = org_survey_cost_key_money_invoice_business_type == undefined ? 0 : org_survey_cost_key_money_invoice_business_type
    let survey_cost_other_invoice_business_type = org_survey_cost_other_invoice_business_type == undefined ? 0 : org_survey_cost_other_invoice_business_type
    let newErrors = {
      ...newData.errors,
      estimate_detail_amt:estimate_detail_name.length>0&&estimate_detail_amt==0?[GetMessage(2547)]: undefined,
      estimate_detail_name:estimate_detail_name.length==0&&estimate_detail_amt>0?[GetMessage(2546)]: undefined,
      estimate_detail_amt_ex:estimate_detail_name_ex.length>0&&estimate_detail_amt_ex==0?[GetMessage(2547)]: undefined,
      estimate_detail_name_ex:estimate_detail_name_ex.length==0&&estimate_detail_amt_ex>0?[GetMessage(2546)]: undefined,
      survey_cost_parking_rent_invoice_registration_number:survey_cost_parking_rent_payment_type == 1 ? this.validateInvoiceNumber(survey_cost_parking_rent_invoice_business_type,survey_cost_parking_rent_invoice_registration_number) : undefined,
      survey_cost_commission_invoice_registration_number:survey_cost_commission_payment_type == 1 ? this.validateInvoiceNumber(survey_cost_commission_invoice_business_type,survey_cost_commission_invoice_registration_number) : undefined,
      survey_cost_key_money_invoice_registration_number:survey_cost_key_money_payment_type == 1 ? this.validateInvoiceNumber(survey_cost_key_money_invoice_business_type,survey_cost_key_money_invoice_registration_number) : undefined,
      survey_cost_other_invoice_registration_number:survey_cost_other_payment_type == 1 ? this.validateInvoiceNumber(survey_cost_other_invoice_business_type,survey_cost_other_invoice_registration_number) : undefined,
      survey_available_start_date: undefined,
      survey_available_end_date: undefined,
    }
    console.log(newData.values,survey_cost_other_invoice_registration_number)
    let supplier_error =  this.validateSupplierInvoiceNumber(newData.values)  
    // console.log(this.alertDateCheck(newData.values),survey_cost_parking_rent,survey_cost_commission,survey_cost_key_money,survey_cost_other,supplier_error)
    console.log(survey_cost_other_invoice_business_type)
    if (this.alertDateCheck(newData.values)){
      this.setState({
        singleData:{
          ...singleData,
          ...newData,
          values:{
            ...newData.values,
            // survey_parking_address_contract,
            /* 免税事業者を選択時に適格事業者番号を空にする処理
            survey_cost_parking_rent_invoice_registration_number: survey_cost_parking_rent_invoice_business_type == 2? "":survey_cost_parking_rent_invoice_registration_number,
            survey_cost_commission_invoice_registration_number: survey_cost_commission_invoice_business_type == 2? "":survey_cost_commission_invoice_registration_number,
            survey_cost_key_money_invoice_registration_number: survey_cost_key_money_invoice_business_type == 2? "":survey_cost_key_money_invoice_registration_number,
            */
          },
          errors: {
            ...newErrors,
            ...(newData.errors.survey_adjustment_amt ? {survey_adjustment_amt : newData.errors.survey_adjustment_amt} : newData.values.survey_adjustment_amt ? {survey_adjustment_amt:[GetMessage(2424), {notIgnore:false}]} : {survey_adjustment_amt:undefined}),
            ...(newData.values.survey_capacity_qty > singleData.values.request_parking_space_qty ? {survey_capacity_qty : [GetMessage(2544)]} : ""),
            survey_cost_parking_rent_payment_type: survey_cost_parking_rent > 0 ? 
                                survey_cost_parking_rent_payment_type == 0 && supplier_error == true ? 
                                  [GetMessage(2602)] :
                                  survey_cost_parking_rent_payment_type == null || 
                                  survey_cost_parking_rent_payment_type == undefined ||
                                  survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == null? 
                                    [GetMessage(2603)] : "" :"",
            survey_cost_commission_payment_type: survey_cost_commission > 0 ? 
                                survey_cost_commission_payment_type == 0 && supplier_error == true ? 
                                  [GetMessage(2602)] :
                                  survey_cost_commission_payment_type == null || 
                                  survey_cost_commission_payment_type == undefined ||
                                  survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == null? 
                                    [GetMessage(2603)] :"":"",
            survey_cost_key_money_payment_type: survey_cost_key_money > 0 ? 
                                survey_cost_key_money_payment_type == 0 && supplier_error == true ? 
                                  [GetMessage(2602)] :
                                  survey_cost_key_money_payment_type == null || 
                                  survey_cost_key_money_payment_type == undefined ||
                                  survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == null? 
                                    [GetMessage(2603)] : "":"",
            survey_cost_other_payment_type: survey_cost_other > 0 ? 
                                survey_cost_other_payment_type == 0 && supplier_error == true ?
                                  [GetMessage(2602)] :
                                  survey_cost_other_payment_type == null || 
                                  survey_cost_other_payment_type == undefined ||
                                  survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == null? 
                                    [GetMessage(2603)] : "":"",
          },
          requiredData: {
            ...newData.requiredData,
          survey_cost_parking_rent_invoice_registration_number: survey_cost_parking_rent_payment_type==1? this.validateInvoiceNumber(survey_cost_parking_rent_invoice_business_type,survey_cost_parking_rent_invoice_registration_number):"",
          survey_cost_commission_invoice_registration_number: survey_cost_commission_payment_type==1? this.validateInvoiceNumber(survey_cost_commission_invoice_business_type,survey_cost_commission_invoice_registration_number):"",
          survey_cost_key_money_invoice_registration_number: survey_cost_key_money_payment_type==1? this.validateInvoiceNumber(survey_cost_key_money_invoice_business_type,survey_cost_key_money_invoice_registration_number):"",
          survey_cost_other_invoice_registration_number: survey_cost_other_payment_type==1? this.validateInvoiceNumber(survey_cost_other_invoice_business_type,survey_cost_other_invoice_registration_number):"",
          }
        }
      }, () => {
        // console.log(this.state.singleData.errors,this.state.data, this.state.singleData);
      })
    }
  }  
  validateSurveyCallback(newData, callback=()=>{}){
//    console.log(newData);
    this.setState({survey_data : newData})
  }
  validateAutoOrderCallback(newData, callback=()=>{}){
    this.setState({
      request_data:{
          ...this.state.request_data,
          values: newData.values
      }
    })
  }

  validateSendContact ( newData, callback=()=>{}) 
  {
    var notification = this.state.notification;

    if ( notification.values.send_setting != newData.values.send_setting ) {
      switch (parseInt(newData.values.send_setting)) {
        case 0:{
          notification.send_mail = true;
          notification.send_fax = true;
        }break;
        case 1:{
          notification.send_mail = true;
          notification.send_fax = false;
        }break;
        case 2:{
          notification.send_mail = false;
          notification.send_fax = true;
        }break;
      }
    }
    if ( notification.values.subcon_send_setting != newData.values.subcon_send_setting ) {
      switch (parseInt(newData.values.subcon_send_setting)) {
        case 0:{
          notification.subcon_send_mail = true;
          notification.subcon_send_fax = true;
        }break;
        case 1:{
          notification.subcon_send_mail = true;
          notification.subcon_send_fax = false;
        }break;
        case 2:{
          notification.subcon_send_mail = false;
          notification.subcon_send_fax = true;
        }break;
      }
    }

//    console.log(notification);
    let assignData = Object.assign(notification, newData);
  //  console.log(assignData);
    this.setState({
        notification:{
          ...notification,
          ...newData,
          values:{
            ...notification.values,
            ...newData.values,
          },
          errors : {
            ...newData.errors,
            fax : newData.values.guide_type == 1 && !newData.values.fax ? undefined : !newData.values.fax ? [GetMessage(2024)] : newData.errors.fax,
            subcon_fax : newData.values.subcon_guide_type == 1 && !newData.values.subcon_fax ? undefined : !newData.values.subcon_fax ? [GetMessage(2024)] : newData.errors.subcon_fax,
          },
            requiredData : {
            ...newData.requiredData,
          }
        },
        isnull_value: {
          ...this.state.isnull_value,
          mail: assignData.values.cc_email === null || assignData.values.cc_email !== null && assignData.values.cc_email.length == 0,
          fax: assignData.values.fax === null || assignData.values.fax !== null && assignData.values.fax.length == 0,
          subcon_mail: assignData.values.subcon_cc_email === null || assignData.values.subcon_cc_email !== null && assignData.values.subcon_cc_email.length == 0,
          subcon_fax: assignData.values.subcon_fax === null || assignData.values.subcon_fax !== null && assignData.values.subcon_fax.length == 0
        }
      }, () => {/*console.log(this.state.notification, this.state.isnull_value);*/}
    );
  }

  alertDateCheck({
    survey_available_start_date,
    survey_available_end_date
  }){
    const {
      survey_available_start_date:prev_survey_available_start_date,
    } = this.state.singleData.values
    if(survey_available_start_date && survey_available_end_date){
      if(moment(survey_available_start_date) > moment(survey_available_end_date)){
        this.setState({
          singleData:{
            ...this.state.singleData,
            values:{
              ...this.state.singleData.values,
              survey_available_start_date:survey_available_start_date,
            },
            errors:{
              ...this.state.singleData.errors,
              ...{[(prev_survey_available_start_date === survey_available_start_date ? 'survey_available_end_date' : 'survey_available_start_date')]:[GetMessage(2461)]},
            }
          }
        })
        return false
      }
    }
    return true
  }

  uploadImageCallback(imageIdList, imageFolderId, selectedId){
//    console.log('imageIdList', imageIdList, imageFolderId, selectedId)
    
    this.setState({
      singleData:{
        ...this.state.singleData,
        values:{
          ...this.state.singleData.values,
          parking_pictures:imageIdList,
          survey_parking_picture_url:selectedId
        },
        errors:Object.keys(this.state.singleData.errors).reduce((acc, key)=>{
          if (key!="survey_parking_picture_url"){
            acc[key] = this.state.singleData.errors[key]
          }
          return acc
        },!selectedId
          ? { survey_parking_picture_url : this.state.singleData.requiredData.survey_parking_picture_url }
          : {}
        ),
      }
    })
  }




  async getMapUrls(resolvedData, requestData){

    const orderedData = Object.values(resolvedData)
//    let promiseList = []

  
    const resolvedDataWithMap = orderedData.reduce((acc, orderedDatum, index)=>{
      const key = orderedDatum.keyForRequestParking
      const coordinateGroupIndex = parseInt(index/3)
      
      return acc
    }, resolvedData)
//    await Promise.all(promiseList).then(r=>r)
    return resolvedDataWithMap
  }

  // ルートマップを作成する
  async createRouteMaps () {
//  createRouteMaps () {
//      Request.setProgress(10, '経路図作成中')
    let {
      mapObjects,
      parkings,
      data
    } = this.state

//    console.log(data)

    let sigleRouteMapUrls = {};
    let baseUrl = "https://www.google.com/maps/dir/?api=1&travelmode=walking" // QRコード用URL生成用パラメータ
    // let basemapUrl = "https://maps.googleapis.com/maps/api/staticmap?key=" + googleMapKey
    let location = window.location;
    let basemapUrl = location.protocol + "//" + location.host + "/api/mapimage?"
    const mapWidth = 1280
    const mapHeight = 1200

    let route_map = {}
    let route_map_zoom = {}

//    console.log(mapObjects)

    let multiRouteMapUrls = mapObjects.map((mo, n)=>{
      let { markers, memos, polygons, directions, base_map } = mo.objects
      let {style, center} = base_map
      console.log(mo.objects)

      let basemapUrlScheme = style.map((sty)=>{
        let keys = Object.keys(sty)
        let values = Object.values(sty)
        return "style=" + keys.map((k,n)=>{return `${k}:${(k=="color"? values[n].replace("#", "0x"): values[n])}`}).join("|")
      })

      // QR用パラメータ*経路検索目的地
      let destinations = []
      let parkingUlids = []

      directions.map((d, i)=>{
          let parking = parkings[n*3+i]
          let { zoom, lat, lng } = data[parking.request_parking_ulid].map_param
          let arrayUrl = []
          arrayUrl.push("size="+mapWidth + "," + mapHeight)
          arrayUrl.push("center="+lat+","+lng)
          arrayUrl.push("zoom="+zoom)

          // let mapUrlParam =  basemapUrl+ `&scale=2&language=ja&size=${mapWidth}x${mapHeight}&zoom=${zoom}&center=${lat},${lng}&` + basemapUrlScheme.join("&")
          
          parkingUlids.push(parking.request_parking_ulid)

          let {
            markers:distinatesMarker, color, weight, opacity,points
          } = d.direction
          // QRコード用URL *経路図用の目的地情報をセット
          destinations.push(distinatesMarker.lat+","+distinatesMarker.lng)
          // QRコード用URL *拡大図URLを生成
          route_map_zoom[parking.request_parking_ulid] = baseUrl + "&origin="+center.lat + "," + center.lng + "&destination=" + distinatesMarker.lat+","+distinatesMarker.lng

          arrayUrl.push(
            "marker="
            + distinatesMarker.lat
            + ',' + distinatesMarker.lng
            + "|distinate"
            + "|" + aryAlphabet[n*3+i]
            + "|" + distinatesMarker.color.replace("#", "0x"))

          let latlngs = points.map((latlng) => latlng.Lat + "," + latlng.Lng).join(' ')
          arrayUrl.push(
            "line="
            + latlngs
            + "|" + color.replace("#", "0x")
            + "|" + weight
            + "|" + opacity)
          // mapUrlParam = mapUrlParam + "&markers=color:"+distinatesMarker.color.replace("#", "0x") +"|label:"+distinatesMarker.text+"|"+distinatesMarker.lat+","+distinatesMarker.lng
          // mapUrlParam = mapUrlParam + "&path=weight:"+ weight +"|color:"+ color.replace("#", "0x") + parseInt(Number(opacity) * 255).toString(16)+"|"+points.map((p)=>{return p.Lat+","+p.Lng}).join("|")

          markers.forEach((marker) => {
            let {lat, lng, start, request_parking_status} = marker
            if(start) {
              // 2061 区画図に「満車」等出さない
              arrayUrl.push(
                "marker=" 
                + lat
                + ',' + lng
                + "|" + (start ? "start" : "flagged")
                + "|" + (start ? "" : request_parking_status)
                + "|"
              )
            }
          })
          // markers.map((mrk)=>{
          //   let {url, lat, lng} = mrk
          //   mapUrlParam = mapUrlParam + `&markers=icon:${url}|${lat},${lng}`
          // })
    
          if (memos.length>0) {
            memos.forEach((mm) => {
              let contents = mm.memo.contents
              let {text, lat, lng} = mm.memo.marker
              arrayUrl.push(
                "marker="
                + lat
                + ',' + lng
                + "|memo"
                + "|" + text
                + "|" + contents
              )
            })
            // memos.map((mm)=>{
            //   let {color, text, lat, lng} = mm.memo.marker
            //   mapUrlParam = mapUrlParam + `&markers=color:${color.replace("#", "0x")}|label:${text}|${lat},${lng}`
            // })
          }
          if (polygons.length>0) {
            polygons.forEach((p) => {
              let {color, fillcolor, opacity, points, weight} = p.polygon
              let latlngs = points.map((latlng) => latlng.lat + "," + latlng.lng).join(' ')
              arrayUrl.push(
                "polygon="
                + latlngs
                + "|" + color.replace("#", "0x")
                + "|" + weight
                + "|" + fillcolor.replace("#", "0x")
                + "|" + opacity)
            })
            // polygons.map((p)=>{
            //   let {color, fillcolor, opacity, points, weight} = p.polygon
            //   mapUrlParam = mapUrlParam + `&path=fillcolor:${fillcolor.replace("#", "0x") + parseInt(Number(opacity) * 255).toString(16)}|weight:${weight}|color:${color.replace("#", "0x")}`
            //   mapUrlParam = mapUrlParam + `|${points.map((p)=>{return p.lat+","+p.lng}).join("|")}`
            // })
          }
          let mapUrlParam = basemapUrl + arrayUrl.join('&')
          console.log(mapUrlParam)
          sigleRouteMapUrls = {
            ...sigleRouteMapUrls,
            [parking.request_parking_ulid]:mapUrlParam
          }
      })

      parkingUlids.forEach((ulid)=>{
        route_map[ulid] = baseUrl+"&origin="+center.lat + "," + center.lng + "&destination=" + destinations.join("|")
      })

      return mo.monochrome_map_url;
    })

    Request.setProgress(20, '経路図作成中')

    const routeData = await StaticMap.createStaticMapForUrls(multiRouteMapUrls)

    Request.setProgress(40, '経路図作成中')

    const syncUpload = await Promise.all(routeData.map((routeDatum)=>{
      return StaticMap.uploadCanvas(routeDatum.canvas, 's_route_picture')
    }))
    const routeDataWithMap = routeData.map((routeDatum,index)=>{
      return {
        ...routeDatum,
        file_id: syncUpload[index].id,
        uploaded_route_url: GoogleDrive.getDownloadUrl(syncUpload[index].id),
      }
    })

    Request.setProgress(70, '経路図作成中')
    const promiseList = []

    let orderedData = Object.values(data)

    const resolvedDataWithMap = orderedData.reduce((acc, orderedDatum)=>{
      // 駐車場IDの取得
      const key = orderedDatum.keyForRequestParking
      //  駐車場一覧からIDの一致する配列のキーを取得し、経路図（広域図）のIDを取得
      let index = parkings.findIndex((p)=>p.request_parking_ulid==key)
      let n = parseInt(index / 3)

      promiseList.push(
        new Promise((resolve,reject)=>{
              StaticMap.uploadZoomedRouteMap(sigleRouteMapUrls[key], 's_route_zm_picture').then(result =>{
                if(result == false) reject();

                acc[key].survey_route_picture_url = routeDataWithMap[n].file_id
                acc[key].ESTIMATE__survey_route_picture_url =  routeDataWithMap[n].uploaded_route_url
                acc[key].survey_route_zoom_picture_url = result.id
                acc[key].ESTIMATE__survey_route_zoom_picture_url = GoogleDrive.getDownloadUrl(result.id)
                acc[key].survey_route_qr_url = route_map[key]
                acc[key].survey_route_zoom_qr_url = route_map_zoom[key]
                acc[key].ESTIMATE__survey_route_qr_url = route_map[key]
                acc[key].ESTIMATE__survey_route_zoom_qr_url = route_map_zoom[key]
                resolve()
            })
        })
      )
      return acc
    }, data)
    Request.setProgress(80, '経路図作成中')
    await Promise.all(promiseList)
    .then(r=>r,e=>{console.log(e);return false;})
    .catch(e=>{console.log(e);return false;})
    ;
    Request.setProgress(0)
    let overlengthUrl = Object.values(sigleRouteMapUrls).filter(url=>url.length>65536);

    return overlengthUrl.length>0 ? false : resolvedDataWithMap

    // return resolvedDataWithMap
  }

  getNumberForCalculation(number){
    return isNaN(parseInt(number)) ? 0 : parseInt(number)
  }    

  async componentDidUpdate(prevProps, prevState){

    // console.log(this.state)

    const {
      survey_available_start_date,
      survey_available_end_date,
      survey_term_month_flag,
      survey_cost_parking_rent:raw_survey_cost_parking_rent,
      survey_capacity_qty:raw_survey_capacity_qty,
      survey_cost_commission:raw_survey_cost_commission,
      survey_cost_key_money:raw_survey_cost_key_money,
      survey_cost_security_deposit:raw_survey_cost_security_deposit,
      estimate_detail_amt:raw_estimate_detail_amt,
      estimate_detail_amt_ex: raw_estimate_detail_amt_ex, // 2023/07/26
      request_type,
      survey_adjustment_amt,
      survey_tax_in_flag,
      survey_commission_discount_rate:raw_survey_commission_discount_rate,
      survey_discount_amt : raw_survey_discount_amt,
      upper_limit_additional_amt,
      survey_key_money,
      survey_commission,
      customer_natural_id,
      survey_subtotal_amt,
      survey_fraction_amt_flag,
      survey_parking_rent,
      _CAL_cost_total_amt,
      cost_total_amt,
      survey_total_amt,
      survey_cost_other: raw_survey_cost_other,
    } = this.state.singleData.values
    const prevStateSingleData = prevState.singleData.values
    if (
      (survey_available_start_date!==prevStateSingleData.survey_available_start_date)||
      (survey_available_end_date!==prevStateSingleData.survey_available_end_date)||
      (survey_term_month_flag!==prevStateSingleData.survey_term_month_flag) ||
      (raw_survey_capacity_qty!==prevStateSingleData.survey_capacity_qty) ||
      (raw_survey_cost_commission!==prevStateSingleData.survey_cost_commission) ||
      (raw_survey_cost_key_money!==prevStateSingleData.survey_cost_key_money) ||
      (raw_survey_cost_security_deposit!==prevStateSingleData.survey_cost_security_deposit) ||
      (raw_survey_discount_amt!==prevStateSingleData.survey_discount_amt) ||
      (survey_adjustment_amt!==prevStateSingleData.survey_adjustment_amt) ||
      (survey_key_money!==prevStateSingleData.survey_key_money) ||
      (survey_commission!==prevStateSingleData.survey_commission) ||
      (raw_survey_cost_other!==prevStateSingleData.survey_cost_other) ||
      (survey_tax_in_flag!==prevStateSingleData.survey_tax_in_flag) ||
      (survey_subtotal_amt!==prevStateSingleData.survey_subtotal_amt) ||
      (survey_fraction_amt_flag!==prevStateSingleData.survey_fraction_amt_flag) ||
      (survey_parking_rent!==prevStateSingleData.survey_parking_rent) ||
      (_CAL_cost_total_amt!==prevStateSingleData._CAL_cost_total_amt) ||
      (cost_total_amt!==prevStateSingleData.cost_total_amt) ||
      (raw_survey_commission_discount_rate!==prevStateSingleData.survey_commission_discount_rate) ||
      (raw_survey_cost_parking_rent!==prevStateSingleData.survey_cost_parking_rent) ||
      (survey_total_amt!==prevStateSingleData.survey_total_amt) ||
      (raw_estimate_detail_amt!==prevStateSingleData.estimate_detail_amt) || 
      (raw_estimate_detail_amt_ex!==prevStateSingleData.estimate_detail_amt_ex)
    ){
    //  console.log(this.state.singleData.values, prevStateSingleData)
      const survey_cost_parking_rent = this.getNumberForCalculation(raw_survey_cost_parking_rent)
      const survey_capacity_qty = this.getNumberForCalculation(raw_survey_capacity_qty)
      const survey_cost_commission = this.getNumberForCalculation(raw_survey_cost_commission)
      const survey_cost_other = this.getNumberForCalculation(raw_survey_cost_other)
      const survey_cost_key_money = this.getNumberForCalculation(raw_survey_cost_key_money)
      const survey_cost_security_deposit = this.getNumberForCalculation(raw_survey_cost_security_deposit)
      const survey_commission_discount_rate = this.getNumberForCalculation(raw_survey_commission_discount_rate)
      const survey_discount_amt = this.getNumberForCalculation(raw_survey_discount_amt)
      const estimate_detail_amt = this.getNumberForCalculation(raw_estimate_detail_amt)
      const estimate_detail_amt_ex = this.getNumberForCalculation(raw_estimate_detail_amt_ex)
      const endDate = new Date(survey_available_end_date)
      const startDate = new Date(survey_available_start_date)

      const {
        monthCount,
        days,
        startDays,
        endDays
      } = await this.getCountsFromDuration(startDate, endDate, survey_term_month_flag)
      const hasFullLastMonth = days==0
      const _CAL_month_qty = this.getNumberForCalculation(monthCount)
      const _CAL_day_qty = (!hasFullLastMonth&&days>0 ? this.getNumberForCalculation(days) : 0)
      
      const firstDay = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      const lastDay = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
      
      const alert = survey_term_month_flag==0?
      (
        //通し無
        (
          (endDate.getTime() != lastDay.getTime())
        ) ? {
          survey_term_alert:[GetMessage(2425), {notIgnore:false}],
        } : ( hasFullLastMonth
          ? {
            survey_term_alert:[GetMessage(2426), {notIgnore:false}],
          }
          : {
            survey_term_alert:undefined,
          }
          )
      ):(
        //通し有
        !hasFullLastMonth?{
          survey_term_alert:[GetMessage(2427),{notIgnore:true}],
        }:{
          survey_term_alert:undefined,
        }
      )
      
      //仕入合計 ___CAL_cost_total_amt  [仕入賃料] * [月数] * [台数] + [仕入賃料] / 30 * [日数] * [台数] + [仕入手数料] * [台数] + [仕入礼金] * [台数]
      const _CAL_cost_total_amt = ( survey_cost_parking_rent * _CAL_month_qty * survey_capacity_qty + parseInt(survey_cost_parking_rent / 30) * _CAL_day_qty * survey_capacity_qty + survey_cost_commission * survey_capacity_qty + survey_cost_key_money * survey_capacity_qty + survey_cost_other)
      
      // ___CAL_cost_security_deposit_total_amt  [仕入敷金] * [台数]
      const _CAL_cost_security_deposit_total_amt = survey_cost_security_deposit * survey_capacity_qty
      
      // survey_parking_rent
      //・[見積賃料] = [仕入賃料] + [上乗せ額]
      // 20200528 new : 正しいのは仕入金額の「賃料（月単価）」＋上乗せ額
      const survey_parking_rent = (this.state.singleData.values.survey_parking_rent === null || this.state.singleData.values.survey_parking_rent === "") ? null 
          :( 
            (survey_cost_parking_rent && survey_cost_parking_rent != this.state.singleData.values.survey_cost_parking_rent)
            ? survey_cost_parking_rent + this.getNumberForCalculation(this.state.singleData.values.survey_parking_rent_profit)
            : this.getNumberForCalculation(this.state.singleData.values.survey_parking_rent)
        )
    
      // survey_parking_rent_profit
      //・[上乗せ額（画面上）] = [見積賃料] - [仕入賃料]
      const survey_parking_rent_profit = ( 
          this.state.singleData.values.survey_parking_rent === null 
            ? null
           : this.getNumberForCalculation(survey_parking_rent) - survey_cost_parking_rent 
        )
      // upper_limit_additional_amt
      const survey_parking_rent_profit_alert = (upper_limit_additional_amt && (upper_limit_additional_amt < survey_parking_rent_profit))
        ? {
          survey_parking_rent_profit_alert:[GetMessage(2429),{notIgnore:false}],
        } : {
          survey_parking_rent_profit_alert : undefined
        }

      // 手数料           survey_commission
      const {
              data:current_data,
              current_ulid
            } = this.state

      const survey_commission = prevStateSingleData.survey_commission != undefined 
            ?
              (prevStateSingleData.survey_parking_rent !== this.state.singleData.values.survey_parking_rent)
              ? (request_type==2) 
                ? (survey_parking_rent == null ? null : this.getNumberForCalculation(survey_parking_rent) * 0.1)
                : (survey_parking_rent == null 
                  ? null 
                  : prevState.current_ulid != this.state.current_ulid
                    ? current_data[current_ulid].survey_commission
                    : this.getNumberForCalculation(survey_parking_rent)) 
              : prevState.current_ulid != this.state.current_ulid
                ? current_data[current_ulid].survey_commission
                : this.state.singleData.values.survey_commission
            : current_data[current_ulid].survey_commission 
              ? current_data[current_ulid].survey_commission
              : this.state.singleData.values.survey_commission

      console.log("survey_commission",survey_commission)
              
      // survey_key_money  見積金額 礼金
      //[仕入礼金]が0の時は0にする。それ以外の時は[仕入礼金]＋[上乗せ額] 
      // const survey_key_money = (prevStateSingleData.survey_key_money != this.state.singleData.values.survey_key_money)
      //   ? this.state.singleData.values.survey_key_money 
      //   : (
      //     (survey_cost_key_money==0)
      //     ? 0 : survey_cost_key_money + survey_parking_rent_profit
      //   )
      
      //  実質手数料
      // [見積手数料] * ( 1 - [手数料割引率] )
      // #2557 【基幹】見積登録画面：実質手数料のプログラム修正（浮動小数点）
      const survey_commission_discount_amt = Math.round(survey_commission * (1 - survey_commission_discount_rate/100))
      
      // 端数調整 survey_fraction_amt_flag
      // 税込の場合は「なし」で固定, 延長時は端数調整はない
      // 【2020/11/25-05】 税込時に10円単位切捨てを選べるようにする
      const survey_fraction_amt_flag = request_type=="2"
        ? 0 
        : this.state.singleData.values.survey_fraction_amt_flag
      
      //  見積小計  survey_subtotal_amt  ?? ___CAL_subtotal_estimate_amt??
      // "[見積賃料] * [月数] * [台数] + [見積賃料] / 30 * [日数] * [台数] + [実質手数料] * [台数] + [見積礼金] * [台数] + [値引額] +[調整金額（東京セキスイ]"	
      // "端数調整がある場合は、10円未満を切り捨て税込の場合表示しない"
      // survey_fraction_amt_flag == 1?
      
      // 積み替え（request_type=3）のとき課税非課税項目を足すと自己更新で無限ループするのでここでは足さない
      const summed_survey_subtotal_amt = (
          survey_parking_rent * _CAL_month_qty * survey_capacity_qty
          + parseInt(survey_parking_rent / 30) * _CAL_day_qty * survey_capacity_qty
          + survey_commission_discount_amt * survey_capacity_qty
          + survey_key_money * survey_capacity_qty
          + survey_discount_amt + this.getNumberForCalculation(survey_adjustment_amt)
          + (estimate_detail_amt ? estimate_detail_amt : 0) 
          // + (estimate_detail_amt_ex ? estimate_detail_amt_ex : 0)
        )
      
      // 10円単位端数切捨てを考慮した非課税金額
      const _estimate_detail_amt_ex = (estimate_detail_amt_ex 
                                        ? (survey_fraction_amt_flag == 1 
                                            ? parseInt(estimate_detail_amt_ex/100)*100 
                                            : estimate_detail_amt_ex) 
                                        : 0)
      // 10円単位端数切り捨て処理
      const _survey_subtotal_amt = (survey_fraction_amt_flag == 1 
        ? parseInt(summed_survey_subtotal_amt/100)*100
        : summed_survey_subtotal_amt)

      // 見積合計 survey_total_amt??? ___CAL_total_estimate_amt_1???
      // 積替は特殊なので別計算（積替以外でもこの計算処理が流れても問題はないので条件分岐はしない）
      const _survey_subtotal_amt_for_tumikae = ((survey_fraction_amt_flag == 1 
        ? parseInt((summed_survey_subtotal_amt + (estimate_detail_amt ? estimate_detail_amt : 0))/100)*100
        : summed_survey_subtotal_amt + (estimate_detail_amt ? estimate_detail_amt : 0))) 
      const survey_total_amt = (
        (
          (survey_tax_in_flag == "1") ? _survey_subtotal_amt : parseInt(_survey_subtotal_amt * 1.1)
        )
      )
      + _estimate_detail_amt_ex
      // console.log(survey_total_amt)

      const survey_subtotal_amt = _survey_subtotal_amt + _estimate_detail_amt_ex

      // 税額 survey_tax_amt
      const survey_tax_amt = survey_tax_in_flag == "1"
      ? parseInt((_survey_subtotal_amt) / 11) : (
        parseInt(_survey_subtotal_amt * 0.1)
      )

      // 利益額 ___CAL_profit_amt
      // [利益額] = [見積合計] - [仕入合計]
      const _CAL_profit_amt = survey_total_amt - _CAL_cost_total_amt
      // 利益率 ___CAL_profit_rate
      // [利益率] = [利益額] / [見積合計] * 100 (%)
      const _CAL_profit_rate = this.getNumberForCalculation(_CAL_profit_amt / survey_total_amt * 10000)/100
      console.log('_CAL_profit_amt', _CAL_profit_amt)
      console.log('survey_total_amt', survey_total_amt)
      console.log('_CAL_cost_total_amt', _CAL_cost_total_amt)

      // 利益率25%まで賃料、手数料がいくら足りないかの計算
      // console.log('_CAL_profit_rate', _CAL_profit_amt)
      var _CAL_survey_parking_rent_rate25 = null
      var _CAL_survey_commission_rate25 = null
      if(_CAL_profit_rate < 25) {
        // 利益率が25%の時の見積合計
        // survey_total_amt = -_CAL_cost_total_amt / (0.25 - 1)
        const _rate25_target_value = -_CAL_cost_total_amt / (0.25 - 1)
        // 利益率25%に対する不足金額
        var _rate25_target_current_diff = _rate25_target_value - survey_total_amt
        // 税込みは税抜に戻す
        // NOTE 元の式がparseIntしてるので　ここでも誤差が出る可能性あり

        _rate25_target_current_diff = ((survey_tax_in_flag == "1") ? _rate25_target_current_diff : _rate25_target_current_diff / 1.1)
        // NOTE
        // _survey_subtotal_amt = (survey_fraction_amt_flag == 1 
        //  ? parseInt(summed_survey_subtotal_amt/100)*100
        //  : summed_survey_subtotal_amt)
        //
        // summed_survey_subtotal_amt = 
        // survey_parking_rent * _CAL_month_qty * survey_capacity_qty
        // + parseInt(survey_parking_rent / 30) * _CAL_day_qty * survey_capacity_qty
        // + survey_commission_discount_amt * survey_capacity_qty
        // + survey_key_money * survey_capacity_qty
        // + survey_discount_amt + this.getNumberForCalculation(survey_adjustment_amt)
        // + (estimate_detail_amt ? estimate_detail_amt : 0) 
        // なので
        // 賃料と手数料だけで25%にするには
        // _rate25_target_current_diff = survey_parking_rent * _CAL_month_qty * survey_capacity_qty
        // + parseInt(survey_parking_rent / 30) * _CAL_day_qty * survey_capacity_qty
        // + survey_commission_discount_amt * survey_capacity_qty
        // になればいい


        // 賃料と手数料の　賃料比率
        const _survey_parking_rent_total = survey_parking_rent * _CAL_month_qty + parseInt(survey_parking_rent / 30) * _CAL_day_qty
        const _parking_rent_commission_ratio = _survey_parking_rent_total / (_survey_parking_rent_total + survey_commission_discount_amt)
        // console.log('###',_parking_rent_commission_ratio)
        // 利益率25%に対する不足金額のうち　賃料分
        const _rate25_part_of_parking_rent = Math.ceil((_rate25_target_current_diff * _parking_rent_commission_ratio))
        // 利益率25%に対する不足金額のうち　手数料分
        const _rate25_part_of_commission = _rate25_target_current_diff - _rate25_part_of_parking_rent
        // console.log('###','不足 '+_rate25_target_current_diff,'賃料 '+_rate25_part_of_parking_rent,'手数料 '+_rate25_part_of_commission)

        // 利益率25%に対する不足賃料計算
        // survey_parking_rent(実質 summed_survey_subtotal_amt)の式のうち
        // survey_parking_rent * _CAL_month_qty * survey_capacity_qty
        // + parseInt(survey_parking_rent / 30) * _CAL_day_qty * survey_capacity_qty
        // の部分が賃料に関係する部分なので
        //
        // _rate25_part_of_parking_rent = survey_parking_rent * _CAL_month_qty * survey_capacity_qty + parseInt(survey_parking_rent / 30) * _CAL_day_qty * survey_capacity_qty
        // _rate25_part_of_parking_rent = survey_capacity_qty * survey_parking_rent * (_CAL_month_qty +  (1 / 30 * _CAL_day_qty))
        // survey_parking_rent = _rate25_part_of_parking_rent / (survey_capacity_qty * (_CAL_month_qty +  (1 / 30 * _CAL_day_qty))
        _CAL_survey_parking_rent_rate25 = Math.ceil(_rate25_part_of_parking_rent / (survey_capacity_qty * (_CAL_month_qty + (1 / 30 * _CAL_day_qty))))
        if(survey_fraction_amt_flag == 1 && _CAL_survey_parking_rent_rate25 % 100 != 0) {
          _CAL_survey_parking_rent_rate25 = Math.ceil(_CAL_survey_parking_rent_rate25/100)*100
        }
        // 利益率25%に対する不足手数料計算
        // _rate25_currentの式のうち
        // survey_commission * (1 - survey_commission_discount_rate/100) * survey_capacity_qty
        // の部分が手数料に関係する部分なので
        //
        // 実質手数料 = 手数料 * (1 - 手数料割引率)
        //
        // _rate25_part_of_commission = survey_commission * (1 - survey_commission_discount_rate/100) * survey_capacity_qty
        // survey_commission = _rate25_part_of_commission / ((1 - survey_commission_discount_rate/100) * survey_capacity_qty)
        // _CAL_survey_commission_rate25 = Math.ceil(_rate25_part_of_commission / ((1 - survey_commission_discount_rate/100) * survey_capacity_qty))
        // _CAL_survey_commission_rate25 = _rate25_part_of_commission * (1 - survey_commission_discount_rate/100) * survey_capacity_qty
        _CAL_survey_commission_rate25 = _rate25_part_of_commission / (1 - survey_commission_discount_rate/100) / survey_capacity_qty
        // _CAL_survey_commission_rate25 = _rate25_part_of_commission 
        if(survey_fraction_amt_flag == 1 && _CAL_survey_commission_rate25 % 100 != 0) {
          _CAL_survey_commission_rate25 = Math.ceil(_CAL_survey_commission_rate25/100)*100
        }
        // console.log('###','賃料不足 ' + _CAL_survey_parking_rent_rate25,'手数料不足 ' + _CAL_survey_commission_rate25)
        // console.log('survey_parking_rent', survey_parking_rent)
        // console.log('survey_commission', survey_commission)
        // console.log('_parking_rent_commission_ratio', _parking_rent_commission_ratio)
        // // console.log('_rate25_current', _rate25_current)
        // // console.log('_rate25_target_value', _rate25_target_value)
        // // console.log('_rate25_target_current_diff', _rate25_target_current_diff)
        // console.log('_rate25_part_of_parking_rent', _rate25_part_of_parking_rent)
        // console.log('_rate25_part_of_commission', _rate25_part_of_commission)
        // console.log('_CAL_survey_parking_rent_rate25', _CAL_survey_parking_rent_rate25)
        // console.log('_CAL_survey_commission_rate25', _CAL_survey_commission_rate25)
      }

      // make estimate details
      // daily fee : parseInt(survey_parking_rent / 30)
      // format : 2019年1月分賃料
      const totalCountForDetails = (startDays?1:0)+(endDays?1:0)+monthCount
      // const incrementalMonthCount = totalCountForDetails>11?2:1
      const incrementalMonthCount = Math.ceil(totalCountForDetails/11)
      // console.log(incrementalMonthCount)
      const estimate_details = this.createEstimateDetails({
        monthCount,
        survey_capacity_qty,
        startDate,
        startDays,
        survey_parking_rent,
        endDays,
        endDate,
        incrementalMonthCount,
        customer_natural_id,
        survey_term_month_flag,
        request_type,
        survey_tax_in_flag,
        survey_subtotal_amt,
        survey_total_amt
      })

      // console.log(survey_parking_rent_for_request_type_3);
      this.setState({
        singleData:{
          ...this.state.singleData,
          values:{
            ...this.state.singleData.values,
            _CAL_month_qty : survey_term_month_flag == 1 && !hasFullLastMonth ? "" : _CAL_month_qty,
            _CAL_day_qty : survey_term_month_flag == 1 && !hasFullLastMonth ? "" : _CAL_day_qty,
            _CAL_cost_total_amt,
            survey_cost_total_amt : _CAL_cost_total_amt,
            _CAL_cost_security_deposit_total_amt,
            survey_cost_security_deposit_total_amt : _CAL_cost_security_deposit_total_amt,
            survey_parking_rent : survey_parking_rent,
            survey_parking_rent_profit,
            // survey_key_money,
            ...{survey_commission : survey_commission === 0 ? 0 : survey_commission},
            survey_commission_discount_amt,
            survey_fraction_amt_flag,
            ...{survey_subtotal_amt:(isNaN(survey_subtotal_amt) || survey_subtotal_amt === null)?0:survey_subtotal_amt},
            survey_tax_amt,
            ...{survey_total_amt:(isNaN(survey_total_amt) || survey_total_amt === null)?0:survey_total_amt},
            _CAL_profit_amt,
            _CAL_profit_rate,
            _CAL_survey_parking_rent_rate25,
            _CAL_survey_commission_rate25,
            estimate_details,
            survey_subtotal_amt_without_estimate_detail_amt_ex: _survey_subtotal_amt,
            fraction_adjustmented_estimate_detail_amt_ex: _estimate_detail_amt_ex,
            survey_capacity_flag_car : this.state.singleData.values.survey_capacity_flag_car ? this.state.singleData.values.survey_capacity_flag_car : 0,
            survey_capacity_flag_light_truck : this.state.singleData.values.survey_capacity_flag_light_truck ? this.state.singleData.values.survey_capacity_flag_light_truck : 0,
            survey_capacity_flag_truck : this.state.singleData.values.survey_capacity_flag_truck ? this.state.singleData.values.survey_capacity_flag_truck : 0,
            survey_capacity_flag_other : this.state.singleData.values.survey_capacity_flag_other ? this.state.singleData.values.survey_capacity_flag_other : 0,
          },
          errors:{
            ...this.state.singleData.errors,
            ...alert,
            ...survey_parking_rent_profit_alert,
            ...(this.state.singleData.errors.survey_adjustment_amt ? {survey_adjustment_amt : this.state.singleData.errors.survey_adjustment_amt} : survey_adjustment_amt ? {survey_adjustment_amt:[GetMessage(2424), {notIgnore:false}]} : {survey_adjustment_amt:undefined}),
            ...{_CAL_profit_amt:_CAL_profit_amt<0?[GetMessage(2430), {notIgnore:false}]:undefined},
            survey_parking_rent : (survey_parking_rent === "" || survey_parking_rent === null) ? [GetMessage(2024)] : survey_parking_rent < 0 ? [GetMessage(2008)] : undefined,
            survey_commission : (survey_commission === "" || survey_commission === null) ? [GetMessage(2024)] : survey_commission < 0 ? [GetMessage(2008)] : undefined,
            survey_commission_amount : (parseInt(_CAL_cost_total_amt) * 1.02) > parseInt(survey_total_amt)? [GetMessageWithParam(2037, {amount: Format.format_number_with_commas(parseInt(_CAL_cost_total_amt) * 1.02 - parseInt(survey_total_amt))}), {notIgnore:false}]: undefined
          }
        }
      })
    }    
  }

  createEstimateDetails(estimateData){
    const {
      monthCount,
      survey_capacity_qty,
      startDate,
      startDays,
      survey_parking_rent,
      endDays,
      endDate,
      incrementalMonthCount,
      customer_natural_id,
      survey_term_month_flag,
      request_type,
      survey_tax_in_flag,
      survey_subtotal_amt,
      survey_total_amt
    } = estimateData
    let estimate_details = []
    
    switch(customer_natural_id){
      case this.customerUseCustomizedEstimate:
        // アイダ設計
        
        const rowCount = (startDays?1:0)+(endDays?1:0)+monthCount
        const lastDayOfMonth = new Date(startDate.getFullYear(), startDate.getMonth()+1, 0)
        const firstDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 1)

        
        if (rowCount>6){
          startDays && (estimate_details.push(
            {
              estimate_detail_qty: survey_capacity_qty,
              estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
              estimate_detail_term: `${startDays}`,
              estimate_detail_term_type:'日',
              estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * survey_capacity_qty,
              estimate_detail_name: `${Format.dateToString(startDate, 'M/D')} ~ ${Format.dateToString(lastDayOfMonth, 'M/D')} 分`,
            }            
          ))
          if(survey_term_month_flag == 0){
            monthCount && (estimate_details.push({
              estimate_detail_name: `${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+(startDays?1:0), 1), 'M/D')} ~ ${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+monthCount+(startDays?1:0), 0), 'M/D')} 分`,
              estimate_detail_qty: survey_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: monthCount,
              estimate_detail_term_type:'ヶ月',
              estimate_detail_amt: survey_parking_rent * survey_capacity_qty * monthCount,
            }))
          } else {
            monthCount && (estimate_details.push({
              estimate_detail_name: `${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+(startDays?1:0), startDate.getDate()), 'M/D')} ~ ${Format.dateToString(new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()), 'M/D')} 分`,
              estimate_detail_qty: survey_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: monthCount,
              estimate_detail_term_type:'ヶ月',
              estimate_detail_amt: survey_parking_rent * survey_capacity_qty * monthCount,
            }))
          }
          endDays && (estimate_details.push({
            estimate_detail_name: `${Format.dateToString(firstDayOfMonth, 'M/D')} ~ ${Format.dateToString(endDate, 'M/D')} 分`,
            estimate_detail_qty: survey_capacity_qty,
            estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
            estimate_detail_term: `${endDays}`,
            estimate_detail_term_type:'日',
            estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * survey_capacity_qty,
          }))
        } else {
          const startDays_start = startDate;
          const startDays_end =  (startDays_start.getFullYear() === endDate.getFullYear() && startDays_start.getMonth() === endDate.getMonth()) ? endDate : new Date(startDays_start.getFullYear(), startDays_start.getMonth() + 1 , 0)
          startDays && (estimate_details.push(
            {
              estimate_detail_qty: survey_capacity_qty,
              estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
              estimate_detail_term: `${startDays}`,
              estimate_detail_term_type:'日',
              estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * survey_capacity_qty,
              estimate_detail_name: `${Format.dateToString(startDate, 'M/D')} ~ ${Format.dateToString(startDays_end, 'M/D')} 分`,
            }            
          ))
          if(survey_term_month_flag == 0){
            for (let i = 1; i<=monthCount; i+=1){
              const calculatedMonth = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
              estimate_details.push({
                estimate_detail_name: `${Format.dateToString(new Date(calculatedMonth.getFullYear(), calculatedMonth.getMonth(), 1), 'M/D')} ~ ${Format.dateToString(new Date(calculatedMonth.getFullYear(), calculatedMonth.getMonth()+1, 0), 'M/D')} 分`,
                estimate_detail_qty: survey_capacity_qty,
                estimate_detail_unit_cost: survey_parking_rent,
                estimate_detail_term: 1,
                estimate_detail_term_type:'ヶ月',
                estimate_detail_amt: survey_parking_rent * survey_capacity_qty,
              })
            }
          } else {
            for (let i = 0; i<monthCount; i+=1){
            const calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
            const calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+1, (startDate.getDate() === 1 ? 0 : endDate.getDate()))
              estimate_details.push({
                estimate_detail_name: `${Format.dateToString(new Date(calculatedMonth_start.getFullYear(), calculatedMonth_start.getMonth(), calculatedMonth_start.getDate()), 'M/D')} ~ ${Format.dateToString(new Date(calculatedMonth_end.getFullYear(), calculatedMonth_end.getMonth(), calculatedMonth_end.getDate()), 'M/D')} 分`,
                estimate_detail_qty: survey_capacity_qty,
                estimate_detail_unit_cost: survey_parking_rent,
                estimate_detail_term: 1,
                estimate_detail_term_type:'ヶ月',
                estimate_detail_amt: survey_parking_rent * survey_capacity_qty,
              })
            }
          }
          endDays && (estimate_details.push({
            estimate_detail_name: `${Format.dateToString(firstDayOfMonth, 'M/D')} ~ ${Format.dateToString(endDate, 'M/D')} 分`,
            estimate_detail_qty: survey_capacity_qty,
            estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
            estimate_detail_term: `${endDays}`,
            estimate_detail_term_type:'日',
            estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * survey_capacity_qty,
          }))
        }
        return estimate_details
      default:
        
//        console.log('monthCount',monthCount, '-incrementalMonthCount', incrementalMonthCount)
        const startDays_start = startDate;
        const startDays_end =  (startDays_start.getFullYear() === endDate.getFullYear() && startDays_start.getMonth() === endDate.getMonth()) ? endDate : new Date(startDays_start.getFullYear(), startDays_start.getMonth() + 1 , 0)
        startDays && (estimate_details.push(
          {
            estimate_detail_name: `${Format.dateToString(startDays_start, 'YYYY年M月分賃料')} (${Format.dateToString(startDays_start, 'M月D日')} ～ ${Format.dateToString(startDays_end, 'M月D日')})`,
            estimate_detail_qty: survey_capacity_qty,
            estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
            estimate_detail_term: `${startDays}`,
            estimate_detail_term_type:'日',
            estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * survey_capacity_qty,
          }
        ))
        if(survey_term_month_flag == 0){
          for (let i = 0; i<monthCount; i+=incrementalMonthCount){
            // const addMonth = (monthCount-incrementalMonthCount<i && monthCount%2!=0) ? 1 : incrementalMonthCount
            const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
            const calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 1)
            const calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+(startDays?1:0), 0)

            let estimate_detail_name = ''
            if(incrementalMonthCount === 1){
              estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
            } else {
              if(calculatedMonth_start.getMonth() === calculatedMonth_end.getMonth()){
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              } else {
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月')}・${(calculatedMonth_start.getFullYear() !== calculatedMonth_end.getFullYear() ? Format.dateToString(calculatedMonth_end, 'YYYY年') : '')}${Format.dateToString(calculatedMonth_end, 'M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              }
            }
            estimate_details.push({
              estimate_detail_name: estimate_detail_name,
              estimate_detail_qty: survey_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
              estimate_detail_term_type:'月',
              estimate_detail_amt: survey_parking_rent * survey_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
            })
          }
        } else {
          for (let i = 0; i<monthCount; i+=incrementalMonthCount){
            // const addMonth = (monthCount-incrementalMonthCount<i && monthCount%2!=0) ? 1 : incrementalMonthCount
            const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
            let calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
            let calculatedMonth_end = "";

            if(startDate.getDate() === 31){
            // #2054 【20240809-02】【基幹】G04_PDF_請求書：不要な行が出力される
            // 見積開始日が31日の場合、かつ
            // 最終行月の末日が31日の場合、見積終了日は見積開始日-1とする
            // 見積開始日が31日の場合、かつ
            // 最終行月の末日が30日の場合、見積終了日は-1しない
            // （30日とする）

              if(i == 0){
                calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
              }else{
                calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+1, 0)
              }

              const calculatedMonth_e = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+1, 0)
              calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), calculatedMonth_e.getDate()-1)
              // console.log(calculatedMonth_start,calculatedMonth_end,calculatedMonth_e)
              if(endDate.getMonth() === calculatedMonth_e.getMonth() && endDate.getDate() != calculatedMonth_end.getDate()){
                calculatedMonth_end = calculatedMonth_e;
              }
            }else if(startDate.getDate() === 30){
              calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
              
              const calculatedMonth_e = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+1, 0)
              if(calculatedMonth_e.getDate() > 30){
                calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), 30-1)
              }else{
                calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), calculatedMonth_e.getDate()-1)
              }
              // console.log(calculatedMonth_start,calculatedMonth_end,calculatedMonth_e)
              if(endDate.getMonth() === calculatedMonth_e.getMonth() && endDate.getDate() != calculatedMonth_end.getDate()){
                calculatedMonth_end = calculatedMonth_e;
              }
            }else{
              calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
              calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth, (startDate.getDate() === 1 ? 0 : endDate.getDate()))
              console.log(calculatedMonth_start,calculatedMonth_end)
            }

            let estimate_detail_name = ''
            if(incrementalMonthCount === 1){
              estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
            } else {
              if(calculatedMonth_start.getMonth() === calculatedMonth_end.getMonth()){
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              } else {
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月')}・${(calculatedMonth_start.getFullYear() !== calculatedMonth_end.getFullYear() ? Format.dateToString(calculatedMonth_end, 'YYYY年') : '')}${Format.dateToString(calculatedMonth_end, 'M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              }
            }
            estimate_details.push({
              estimate_detail_name: estimate_detail_name,
              estimate_detail_qty: survey_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
              estimate_detail_term_type:'月',
              estimate_detail_amt: survey_parking_rent * survey_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
            })
          }
        }
        const endDays_start = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        const endDays_end =  endDate;
        endDays && (estimate_details.push({
          estimate_detail_name: `${Format.dateToString(endDays_start, 'YYYY年M月分賃料')} (${Format.dateToString(endDays_start, 'M月D日')} ～ ${Format.dateToString(endDays_end, 'M月D日')})`,
          estimate_detail_qty: survey_capacity_qty,
          estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
          estimate_detail_term: `${endDays}`,
          estimate_detail_term_type:'日',
          estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * survey_capacity_qty,
        }))
        return estimate_details
    } 
  }

  getCountsFromDuration(startDate, endDate, survey_term_month_flag){
    return new Promise(async resolve=>{

      startDate.setHours(0)
      endDate.setHours(0)

      if (survey_term_month_flag=="0"){
        const startMonthEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1)
        const endDateIsLast = (endDate.getTime() == (new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0)).getTime())
        const startDays = await (()=>{
          if (startMonthEndDate>endDate && !endDateIsLast){
            return ((endDate - startDate) /1000/60/60/24) + 1
          }else if ( startDate.getDate()=="1"){
            return 0
          } else {
            return ((startMonthEndDate - startDate) /1000/60/60/24)
          }
        })()
        const startDateOfEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0)
        const endDays = (endDateIsLast || (startDate.getFullYear() == endDate.getFullYear() && startDate.getMonth()==endDate.getMonth()))
          ? 0
          : ((endDate-startDateOfEndDate)/1000/60/60/24)
        let monthCount = 0
        while ( new Date(startDate.getFullYear(), startDate.getMonth() + 1 + monthCount, 1) < new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1) ){
          monthCount += 1
        }
        const days = startDays + endDays

        endDateIsLast && (startDays==0&&endDays==0) && monthCount++;

        (startDays!==0&&endDays!==0) && monthCount--;

        resolve({
          monthCount:monthCount<0?0:monthCount,
          days:parseInt(days),
          startDays:parseInt(startDays),
          endDays:parseInt(endDays)
        })
      } else {
        let monthCount = 0
        while ( new Date(startDate.getFullYear(), startDate.getMonth() + monthCount, (startDate.getDate()-1) ) < endDate ){
          monthCount += 1
        }
        const checkDate = new Date(startDate.getFullYear(), startDate.getMonth() + monthCount, (startDate.getDate()-1) );
        let days = (endDate - checkDate ) /1000/60/60/24; 

        // 下記の場合は通し有エラーとしない
        // 見積開始日が30or31日の場合、かつ
        // 最終行月の末日が見積開始日-1日の日付(29,30日)が存在しない場合、見積終了日は月の末日（28or29日）とする
        // （2月のみの想定）
        // console.log(startDate.getMonth(),endDate.getMonth());
        if(endDate.getMonth() == 1 ){
         if( endDate.getDate() == 28 || endDate.getDate() == 29 ){
          if ( startDate.getDate() == 30 || startDate.getDate() == 31 ){
            days = 0
          }
         } 
        }else{
        // エラーになるように調整3月2日、（うるう年対策）3月1日
          if(startDate.getDate() == 31){
            if(endDate.getMonth() == 2){
              if( endDate.getDate() == 2 || endDate.getDate() == 1 ){
                days = 1
              }
            }
          }
        }
        
        resolve({
          monthCount,
          days:parseInt(days),
        })
      }
    })
  }

  getStateToDataForm(){
    const {
      singleData:{
        values
      },
      current_ulid,
      data
    } = this.state
    let newData = Object.assign({}, data);
    console.log(values);
    newData[current_ulid] = {
      ...values,
      estimate_status:2,
      register_type : this.state.request_data.register_type
    }
    return newData

  }

  // ページ移動
  async setSingleDatum(dataKey, saveCurrent = true){
    if (this.validate()){
      if (this.state.current_ulid == dataKey){
        return
      }
      
      const {
        data
      } = this.state

      const index = this.state.parkings.findIndex((p)=>p.request_parking_ulid == dataKey)
      const new_next_ulid = (index>-1 && this.state.parkings.length>index+1)?this.state.parkings[index+1].request_parking_ulid : undefined
      const newData = saveCurrent?this.getStateToDataForm():data
      const requiredCheckedSingleData = await Request.getRequiredData('/api/estimate', {values:data[dataKey]})
      const {
        survey_tax_in_flag,
        survey_subtotal_amt,
        survey_total_amt,
        estimate_detail_amt,
        estimate_detail_amt_ex,
        request_type,
        survey_parking_rent,
        survey_site_distance_meter,
        survey_site_distance_minute
      } = requiredCheckedSingleData.values;
      // console.log(requiredCheckedSingleData.values);
      const {
        site_distance_meter,
        site_distance_minute
      } = this.state.parkings[index] || {};

      this.setState({
        data: newData,
        singleData:{
          ...requiredCheckedSingleData,
          values : {
            ...requiredCheckedSingleData.values,
            survey_subtotal_amt:survey_subtotal_amt,
            survey_site_distance_meter:site_distance_meter != undefined ? site_distance_meter : survey_site_distance_meter,
            survey_site_distance_minute:site_distance_minute != undefined ? site_distance_minute : survey_site_distance_minute
          },
          errors : {
            ...requiredCheckedSingleData.errors,
            cost_total_amt : undefined
          },
          requiredData : {
            ...requiredCheckedSingleData.requiredData,
            cost_total_amt : undefined
          },
        },
        current_ulid: dataKey,
        next_ulid:new_next_ulid,
        doneEstimate:[...this.state.doneEstimate, dataKey],
        syncMapParamters: false,
      }, ()=>setTimeout(()=>{
        const inputNodes = document.getElementsByTagName("input")
        for (let node of inputNodes) {
          node.touch&&node.touch()
        }
      },500))
    }
  }

  getErrors = (values, requiredData) => {
    let errors = {};
    Object.keys(requiredData).forEach((key)=>{
      if(values[key] === undefined || values[key] === null || values[key] === ""){
        errors[key] = requiredData[key]
      }
    })
    return errors;
  }

  //登録モーダル表示/非表示
  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }

  //編集更新モーダル表示/非表示
  toggleUpdateModal() {
    this.setState({
      update_modal: !this.state.update_modal
    });
  }

  toggleSubRegistModal() {
    if (this.props.match.params.construction_id != undefined) {
      return null;
    } else {
      this.setState({
        sub_regist_modal: !this.state.sub_regist_modal
      });
    }
  }

    //PDF作成許可モーダル表示/非表示
    togglePdfRegistModal(estimate_pdf_check) {
      let dataList = this.state.dataList;
      let pdf_created = estimate_pdf_check !== undefined ? this.state.pdf_created : false;
      let pdf_registed = estimate_pdf_check !== undefined ? this.state.pdf_registed : false;
      if(estimate_pdf_check !== undefined){
        const keys = Object.keys(dataList);
  
        keys.forEach(key => {
          dataList[key]["estimate_pdf_check"] = estimate_pdf_check
        })
  
      }

      this.setState({
        pdf_regist_modal: !this.state.pdf_regist_modal,
        estimate_regist_flg: estimate_pdf_check !== undefined ? !estimate_pdf_check : this.state.estimate_regist_flg,
        dataList,
        pdf_created,
        pdf_registed,
      });
    }

    async pdfCreateReqest(){
      if(!this.state.Pdf02final || !this.state.Pdf02final.spreadsheet_id){
        Request.setProgress(0)
        return undefined;
      }
      let params = this.state.mapParams
      params["main_sheet"] = "C02_PDF"
      params["sheet_id"] = this.state.Pdf02final && this.state.Pdf02final.spreadsheet_id ? this.state.Pdf02final.spreadsheet_id : ""
      params["estimate_pdf_check"] = false;
      params["pdf_upload_off"] = true;		
      // console.log(params)

      return new Promise((resolve, reject)=>{ 
        Request.post("/api/pout/pdf_create", params, res=>{
          if (res.Code>=800){
            Request.setProgress(0)
            resolve(undefined)
          } else {
            resolve(res.Data)
          }
        }, err=>{
          reject(err)
        })
      })
    }

    //PDF作成
    async pdfCreate(){
      let PdfData = await this.pdfCreateReqest()

      let Pdf01final = this.state.Pdf01final;
      let Pdf02final = this.state.Pdf02final;
      if(PdfData == undefined || !PdfData.file_id ){
        this.props.alertModal.current.showErrorModal({messageNo:2406})
        return ;
      }
      Pdf02final["file_id"] = PdfData.file_id;
      
      let Pdf01Check = true;
      Pdf01final && Pdf01final.length>0 && await Pdf01final.forEach((pdf01result)=>{
        pdf01result.forEach(item => {
          if (item){
            const {
              file_id
            } = item
            if(!file_id){
              Pdf01Check = false;
            }
            file_id&&window.open(`https://drive.google.com/uc?export=download&id=${file_id}`)
          }
        })
      })
      Pdf02final && window.open(`https://drive.google.com/uc?export=download&id=${Pdf02final.file_id}`)
      let pdf_registed = true;
      if(!Pdf02final.file_id || !Pdf01Check){
        pdf_registed = false;
      }

      this.setState({
        pdf_registed: pdf_registed
      });
    }

  requestEstimatePDF(estimateCommon, estimate){

    const {
      request_type,
      survey_subtotal_amt,
      estimate_detail_amt,
      estimate_detail_amt_ex
    } = estimate

    const estimateCommonParams = {
      ...estimateCommon,
      object_estimate:{
        ...estimateCommon.object_estimate,
        ESTIMATE__survey_subtotal_amt:survey_subtotal_amt
      }
    }

    const estimateData = {
      ...estimate,
      survey_subtotal_amt:survey_subtotal_amt
    }

    console.log(estimateCommonParams,estimateData)

    const {
      invoice_customer_user_setting,
      customer_branch_invoice_zip_code,
      customer_branch_invoice_prefecture,
      customer_branch_invoice_city,
      customer_branch_invoice_address,
      invoice_customer_user_name,
      customer_user_name
    } = this.state.request_data
    
    const invoice_user_name = invoice_customer_user_setting == 1 
    ? invoice_customer_user_name
    : invoice_customer_user_setting == 2 
      ? customer_user_name
      : ""

    const {
      web_survey_account,
      onsite_survey_account
    } = this.state.survey_data.values
    const web_survey_account_info = this.state.landmark_user.find((user)=>(user.value === web_survey_account))
    const onsite_survey_account_info = this.state.landmark_user.find((user)=>(user.value === onsite_survey_account))

    const object_user_info = {
      object_user_web_survey : {
        USER__name:web_survey_account_info ? web_survey_account_info.label : null,
        USER__user_tel:web_survey_account_info ? web_survey_account_info.tel : null,
      },
      object_user_onsite_survey : {
        USER__name:onsite_survey_account_info ? onsite_survey_account_info.label : null,
        USER__user_tel:onsite_survey_account_info ? onsite_survey_account_info.tel : null,
      }
    }
    // console.log(estimateData)
    return (this.customerUseCustomizedEstimate==estimateData.customer_natural_id)
     ? new Promise(async (resolve, reject)=>{      
        const {
          survey_pay_unit_type_day,
          survey_site_distance_meter,
          survey_site_distance_minute,
          survey_capacity_flag_car,
          estimate_details,
          survey_available_start_date,
          estimate_detail_name,
          estimate_detail_name_ex,
          estimate_detail_amt,
          estimate_detail_amt_ex,
          survey_subtotal_amt
        } = estimateData

        let object_array_detail = {}
        let array_count=0
        for(let i=1;i<=6;i++){
          const estimateDetail = estimate_details[i-1]
          if (estimateDetail){
            array_count++
            object_array_detail[`row_start_${i}`] = {
              ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
              ESTIMATE__survey_capacity_qty: estimateDetail.estimate_detail_qty,
              ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
              ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
              ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
              ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt,
            }
          } else {
            object_array_detail[`row_start_${i}`] = {
              ESTIMATE_DETAIL__estimate_detail_name: "",
              ESTIMATE__survey_capacity_qty: "",
              ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
              ESTIMATE_DETAIL__estimate_detail_term: "",
              ESTIMATE_DETAIL__estimate_detail_term_type: "",
              ESTIMATE_DETAIL__estimate_detail_amt: ""
            }
          }
        }

        // 見積情報：発注期限
        // Today と　契約開始日（ESTIMATE__survey_available_start_date）間の営業日数を出し、5営業日以上ある場合、契約開始日の4営業日前の日にちをセットする。
        // Today と　契約開始日（ESTIMATE__survey_available_start_date）間の営業日数を出し、5営業日未満の場合、契約開始日の1営業日前をセットする。
        const CALC_Limit_data = await new Promise(resolve => {
          Request.get('/api/workday', { add_day : 5 }, res => {
            const dateFrom = moment(res.Data);
            const dateTo = moment(survey_available_start_date);
            const diffDays = dateFrom.diff(dateTo, "days")
            Request.get('/api/workday', { set_date : moment(survey_available_start_date).format('YYYY-MM-DD'), prev_flag : "1", add_day : diffDays <= 0 ? 4 : 1 }, res => {
              resolve(res.Data)
            })
          })
        })
        
        const pdfParams = {
          ...estimateCommonParams,
          format_url:GoogleDrive.getFormatUrl((estimateCommonParams.CUSTOMER_BRANCH__estimate_format_url
          ?estimateCommonParams.CUSTOMER_BRANCH__estimate_format_url
          :format_url.Y09_PDF)),
          pdf_upload_off: true,		
          object_each_data:{

            CALC_Limit_data : CALC_Limit_data,
            ESTIMATE_DETAIL__estimate_detail_unit_cost : estimate_details[0].estimate_detail_unit_cost,

            ESTIMATE__survey_pay_unit_type_day: FormatCode.decode("cst_pay_unit_type_day",survey_pay_unit_type_day),
            ESTIMATE__survey_site_distance_meter: survey_site_distance_meter,
            ESTIMATE__survey_site_distance_minute: survey_site_distance_minute,
            ESTIMATE__survey_capacity_flag_car: survey_capacity_flag_car=="1"?"ワゴン車可":"ワゴン車不可",
            CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
            JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
            CUSTOMER_USER__customer_user_name : invoice_user_name,
            ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
            ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
            ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
            ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
            ESTIMATE__other_tax_total_amt:survey_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
            ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計	
            object_array_detail
          },
          object_common:{
            ...estimateCommonParams.object_common,
            array_count
          },
          ...object_user_info
        }
        Request.post('/api/pout/Y09_PDF', pdfParams, res1=>{
          if (res1.Code>=800){
            Request.setProgress(0)
            resolve(undefined)
          } else {
            Request.post('/api/pout/Y09_PDF', {custom_template_pdf : true, ...pdfParams}, res2=>{
              if (res2.Code>=800){
                Request.setProgress(0)
                resolve(undefined)
              } else {
                resolve([res1.Data, res2.Data])
              }
            }, err => {
              reject(err)
            })
          }
        }, err => {
          reject(err)
        })
      })
    : (this.customerUseCustomizedEstimateForTouken==estimateData.customer_natural_id) ?
        new Promise((resolve, reject)=>{
          const {
            survey_capacity_qty,
            survey_capacity_qty_type,
            survey_tax_in_flag,
            survey_available_start_date,
            survey_available_end_date,
            survey_discount_amt,
            survey_key_money,
            survey_commission_discount_amt,
            survey_adjustment_amt,
            survey_subtotal_amt,
            survey_tax_amt,
            survey_total_amt,
            estimate_details,
            estimate_detail_name,
            estimate_detail_name_ex,
            estimate_detail_amt,
            estimate_detail_amt_ex,
          } = estimateData

          let object_array_detail = {}
          let array_count = 0
          for(let i=1;i<=11;i++){
            const estimateDetail = estimate_details[i-1]
            if (estimateDetail){
              array_count++
              object_array_detail[`row_start_${i}`] = {
                ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
                ESTIMATE__survey_capacity_qty: estimateDetail.estimate_detail_qty, // ESTIMATE__survey_capacity_qty
                ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
                ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
                ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
                ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt
              }
            } else {
              object_array_detail[`row_start_${i}`] = {
                ESTIMATE_DETAIL__estimate_detail_name: "",
                ESTIMATE__survey_capacity_qty: "",
                ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
                ESTIMATE_DETAIL__estimate_detail_term: "",
                ESTIMATE_DETAIL__estimate_detail_term_type: "",
                ESTIMATE_DETAIL__estimate_detail_amt: ""
              }
            }
          }
          
          const pdfParams = {
            ...estimateCommonParams,
            format_url:GoogleDrive.getFormatUrl((estimateCommonParams.CUSTOMER_BRANCH__estimate_format_url
            ?estimateCommonParams.CUSTOMER_BRANCH__estimate_format_url
            :format_url.Y12_PDF)),
            pdf_upload_off: true,		
            object_each_data:{
              ESTIMATE__survey_capacity_qty:survey_capacity_qty,
              ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
              CUSTOMER_BRANCH__tax_in_flag:survey_tax_in_flag,
              ESTIMATE__survey_available_start_date: survey_available_start_date,
              ESTIMATE__survey_available_end_date: survey_available_end_date,
              ESTIMATE__survey_discount_amt: survey_discount_amt,
              ESTIMATE__survey_key_money:survey_key_money,
              ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
              ESTIMATE__survey_adjustment_amt: (survey_adjustment_amt === null || survey_adjustment_amt === undefined) ? 0 : survey_adjustment_amt,
              ESTIMATE__survey_subtotal_amt: survey_subtotal_amt,
              ESTIMATE__survey_tax_amt:survey_tax_amt,
              ESTIMATE__survey_total_amt:survey_total_amt,
              CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
              JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
              CUSTOMER_USER__customer_user_name : invoice_user_name,
              ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
              ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
              ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
              ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
              ESTIMATE__other_tax_total_amt:survey_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
              ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計	
              object_array_detail
            },
            object_common:{
              ...estimateCommonParams.object_common,
              array_count
            },
            ...object_user_info
          }
          Request.post('/api/pout/Y12_PDF', pdfParams, res1=>{
            if (res1.Code>=800){
              Request.setProgress(0)
              resolve(undefined)
            } else {
              Request.post('/api/pout/Y12_PDF', {custom_template_pdf : true, ...pdfParams}, res2=>{
                if (res2.Code>=800){
                  Request.setProgress(0)
                  resolve(undefined)
                } else {
                  resolve([res1.Data, res2.Data])
                }
              }, err => {
                reject(err)
              })
            }
          }, err => {
            reject(err)
          })
        })
      : new Promise((resolve, reject)=>{
        const {
          survey_capacity_qty,
          survey_capacity_qty_type,
          survey_tax_in_flag,
          survey_available_start_date,
          survey_available_end_date,
          survey_discount_amt,
          survey_key_money,
          survey_commission_discount_amt,
          survey_adjustment_amt,
          survey_subtotal_amt,
          survey_tax_amt,
          survey_total_amt,
          estimate_details,
          estimate_detail_name,
          estimate_detail_name_ex,
          estimate_detail_amt,
          estimate_detail_amt_ex,
        } = estimateData

        let object_array_detail = {}
        let array_count = 0
        for(let i=1;i<=11;i++){
          const estimateDetail = estimate_details[i-1]
          if (estimateDetail){
            console.log(estimateDetail)
            array_count++
            object_array_detail[`row_start_${i}`] = {
              ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
              ESTIMATE__survey_capacity_qty: estimateDetail.estimate_detail_qty, // ESTIMATE__survey_capacity_qty
              ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
              ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
              ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
              ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt
            }
          } else {
            object_array_detail[`row_start_${i}`] = {
              ESTIMATE_DETAIL__estimate_detail_name: "",
              ESTIMATE__survey_capacity_qty: "",
              ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
              ESTIMATE_DETAIL__estimate_detail_term: "",
              ESTIMATE_DETAIL__estimate_detail_term_type: "",
              ESTIMATE_DETAIL__estimate_detail_amt: ""
            }
          }
        }
        
        let format_url_data =  estimateCommonParams.CUSTOMER_BRANCH__estimate_format_url
          ?estimateCommonParams.CUSTOMER_BRANCH__estimate_format_url
          :format_url.C01_PDF
        let url = "/api/pout/C01_PDF";
        
        // #1849 大成建設ハウジング独自帳票 東海・九州
        if (this.customerUseCustomizedEstimateForTaiseiHousing == estimateData.customer_natural_id && 
            this.customerUseCustomizedEstimateForTaiseiHousingBranch.includes(estimateData.customer_branch_natural_id)) {
              format_url_data = format_url.Y15_PDF
              url = "/api/pout/Y15_PDF";
        }

        // #1942 大成建設ハウジング独自帳票 近畿
        if (this.customerUseCustomizedEstimateForTaiseiHousing == estimateData.customer_natural_id && 
            this.customerUseCustomizedEstimateForTaiseiHousingBranch2.includes(estimateData.customer_branch_natural_id)) {
            format_url_data = format_url.Y16_PDF
            url = "/api/pout/Y16_PDF";
        }

        console.log(format_url_data);
        const pdfParams = {
          ...estimateCommonParams,
          format_url:GoogleDrive.getFormatUrl(format_url_data),
          estimate_pdf_check:estimateData["estimate_pdf_check"] || false,
          customer_system_use_flag:estimateData["customer_system_use_flag"],
          pdf_upload_off: true,		
          object_each_data:{
            ESTIMATE__survey_capacity_qty:survey_capacity_qty,
            ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
            CUSTOMER_BRANCH__tax_in_flag:survey_tax_in_flag,
            ESTIMATE__survey_available_start_date: survey_available_start_date,
            ESTIMATE__survey_available_end_date: survey_available_end_date,
            ESTIMATE__survey_discount_amt: survey_discount_amt,
            ESTIMATE__survey_key_money:survey_key_money,
            ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
            ESTIMATE__survey_adjustment_amt: (survey_adjustment_amt === null || survey_adjustment_amt === undefined) ? 0 : survey_adjustment_amt,
            ESTIMATE__survey_subtotal_amt:survey_subtotal_amt,
            ESTIMATE__survey_tax_amt:survey_tax_amt,
            ESTIMATE__survey_total_amt:survey_total_amt,
            CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
            JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
            CUSTOMER_USER__customer_user_name : invoice_user_name,
            ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
            ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
            ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
            ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
            ESTIMATE__other_tax_total_amt:survey_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
            ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計	
            object_array_detail
          },
          object_common:{
            ...estimateCommonParams.object_common,
            array_count
          },
          ...object_user_info
        }
        console.log(pdfParams);
        Request.post(url, pdfParams, res=>{
          if (res.Code>=800){
            Request.setProgress(0)
            resolve(undefined)
          } else {
            this.state.cu_file["C01_PDF"] = res.Data.cu_file 
            resolve([res.Data])
          }
        }, err => {
          reject(err)
        })
      })
  }
  
  async requestEstimateMapPDF(dataList){
    // C02_PDF_現場から駐車場までの地図 loop?
    const{
      request_natural_id,
      project_natural_id,
      customer_branch_natural_id,
      customer_user_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      user_branch_natural_id
    } = this.state.request_data

    const {
      web_survey_account,
      onsite_survey_account
    } = this.state.survey_data.values
    const web_survey_account_info = this.state.landmark_user.find((user)=>(user.value === web_survey_account))
    const onsite_survey_account_info = this.state.landmark_user.find((user)=>(user.value === onsite_survey_account))

    const object_user_info = {
      object_user_web_survey : {
        USER__name: web_survey_account_info ? web_survey_account_info.label : null,
        USER__user_tel : web_survey_account_info ? web_survey_account_info.tel : null
      },
      object_user_onsite_survey : {
        USER__name: onsite_survey_account_info ? onsite_survey_account_info.label : null,
        USER__user_tel : onsite_survey_account_info ? onsite_survey_account_info.tel : null
      }
    }

    const mapUrl = '/api/pout/C02_PDF'
    const estimateData = dataList[Object.keys(dataList)[0]]

    const estimateCommonParams = await Request.getEstimateCommon({
      customer_branch_natural_id,
      customer_user_natural_id,
      project_natural_id,
      request_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      estimateObject: estimateData,
      user_branch_natural_id
    })
    
    const estimateUlidArray = Object.keys(dataList)
    let object_array_detail = {}
    let array_count=0
    let n;
    let objectMemo = this.state.copyRouteMapFlag &&
                    this.state.request_data.route_map_memo && 
                    this.state.request_data.route_map_memo.length>0? 
                    JSON.parse(this.state.request_data.route_map_memo) : {}

    for(let i=1;i<=15;i++){
      n = i-1;
      const estimateData = dataList[estimateUlidArray[i-1]]
      let memo = ""

      if ( this.state.copyRouteMapFlag ) {
        if ( objectMemo && Object.keys(objectMemo).length > 0 && 
             objectMemo[parseInt(n/3)] && 
             objectMemo[parseInt(n/3)][n%3] ) 
        {
          memo = objectMemo[parseInt(n/3)][n%3]
        }
      }
      else {
        if ( this.state.mapObjects[parseInt(n/3)] && this.state.mapObjects[parseInt(n/3)].objects.memos.length > (n%3) ) {
          memo = this.state.mapObjects[parseInt(n/3)].objects.memos[n%3].memo.contents
        }
      }



      if (estimateData){
        let {
          survey_route_picture_url,
          survey_parking_name,
          survey_parking_prefecture,
          survey_parking_city,
          survey_parking_address,          
          survey_parking_address_contract,
          survey_site_distance_minute,
          survey_site_distance_meter,
          survey_capacity_flag_car,
          survey_capacity_flag_light_truck,
          // survey_capacity_flag_other,
          survey_capacity_flag_truck,
          survey_capacity_special_request,
          survey_capacity_qty,
          survey_capacity_qty_type,
          survey_pay_unit_type_day,
          survey_pay_unit_type_month,
          survey_cost_key_money,
          survey_available_start_date,
          request_parking_status,
          request_parking_space_qty,
          survey_parking_picture_url,
          ESTIMATE__survey_route_picture_url,
          ESTIMATE__survey_route_zoom_picture_url,
          ESTIMATE__survey_route_qr_url,
          ESTIMATE__survey_route_zoom_qr_url,
          request_parking_history: {
            request_parking_status : REQUEST_PARKING_HISTORY__request_parking_status
          }
        } = estimateData
        console.log(REQUEST_PARKING_HISTORY__request_parking_status);
        survey_capacity_special_request = survey_capacity_special_request == null? "":survey_capacity_special_request 
        array_count++
        object_array_detail[`row_start_${i}`] = {
          ESTIMATE__latest_pdf_route_url:ESTIMATE__survey_route_picture_url||"",
          ESTIMATE__survey_parking_name:survey_parking_name||"",
          ESTIMATE__survey_parking_address_contract: survey_parking_address_contract||"",
          JOIN_parking_addr: FormatCode.decode("cst_prefecture", survey_parking_prefecture) + (survey_parking_city||"") + (survey_parking_address||""),
          ESTIMATE__survey_parking_picture_url:GoogleDrive.getDownloadUrl(survey_parking_picture_url)||"",
          ESTIMATE__survey_site_distance_minute:survey_site_distance_minute,
          ESTIMATE__survey_site_distance_meter:survey_site_distance_meter,
          ESTIMATE__survey_capacity_flag_car: FormatCode.decode("cst_ab_select", survey_capacity_flag_car)||"",
          ESTIMATE__survey_capacity_flag_light_truck: FormatCode.decode("cst_ab_select", survey_capacity_flag_light_truck)||"",
          ESTIMATE__survey_capacity_flag_truck: FormatCode.decode("cst_ab_select", survey_capacity_flag_truck)||"",
          ESTIMATE__survey_capacity_special_request:survey_capacity_special_request||"",
          ESTIMATE__survey_capacity_qty:survey_capacity_qty||"",
          ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type)||"",
          ESTIMATE__survey_pay_unit_type_day:FormatCode.decode("cst_pay_unit_type_day", survey_pay_unit_type_day)||"",
          ESTIMATE__survey_pay_unit_type_month: FormatCode.decode("cst_pay_unit_type_month", survey_pay_unit_type_month)||"",
          ESTIMATE__survey_cost_key_money:survey_cost_key_money===undefined?"":survey_cost_key_money,
          ESTIMATE__survey_available_start_date:survey_available_start_date||"",
          REQUEST_PARKING__request_parking_status:request_parking_status==="undefined"?"":request_parking_status,
          REQUEST_PARKING__request_parking_space_qty:request_parking_space_qty===undefined?"":request_parking_space_qty,
          REQUEST__route_map_memo: memo,
          ESTIMATE__survey_route_picture_url,
          ESTIMATE__survey_route_zoom_picture_url,
          ESTIMATE__survey_route_qr_url,
          ESTIMATE__survey_route_zoom_qr_url,
          // #1539 旧ステータス対応
          REQUEST_PARKING_HISTORY__request_parking_status:REQUEST_PARKING_HISTORY__request_parking_status=="2"?REQUEST_PARKING_HISTORY__request_parking_status:"1",
        }
      } else {
        object_array_detail[`row_start_${i}`] = {
          ESTIMATE__latest_pdf_route_url:"",
          ESTIMATE__survey_parking_name:"",
          ESTIMATE__survey_parking_address_contract:"",
          ESTIMATE__survey_site_distance_minute:"",
          ESTIMATE__survey_site_distance_meter:"",
          ESTIMATE__survey_parking_picture_url:"",
          ESTIMATE__survey_capacity_flag_car:"",
          ESTIMATE__survey_capacity_flag_light_truck:"",
          ESTIMATE__survey_capacity_flag_truck:"",
          ESTIMATE__survey_capacity_special_request:"",
          ESTIMATE__survey_capacity_qty:"",
          ESTIMATE__survey_capacity_qty_type:"",
          ESTIMATE__survey_pay_unit_type_day:"",
          ESTIMATE__survey_pay_unit_type_month:"",
          ESTIMATE__survey_cost_key_money:"",
          ESTIMATE__survey_available_start_date:"",
          REQUEST_PARKING__request_parking_status:"",
          REQUEST_PARKING__request_parking_space_qty:"",
          JOIN_parking_addr: "",
          REQUEST__route_map_memo: memo,
          ESTIMATE__survey_route_picture_url:"",
          ESTIMATE__survey_route_zoom_picture_url:"",
          ESTIMATE__survey_route_qr_url:"",
          ESTIMATE__survey_route_zoom_qr_url:"",
          // #1539 旧ステータス対応
          REQUEST_PARKING_HISTORY__request_parking_status:"",
        }
      }
    }
//    console.log(object_array_detail)
    const mapParams = {
      ...estimateCommonParams,
      format_url:GoogleDrive.getFormatUrl(format_url.C02_PDF),
      object_each_data:{object_array_detail},
      object_common:{
        ...estimateCommonParams.object_common,
        array_count
      },
      ...object_user_info,
      estimate_pdf_check:estimateData["estimate_pdf_check"] || false,
      customer_system_use_flag:estimateData["customer_system_use_flag"],
      pdf_upload_off: true,		
    }

    this.setState({
      mapParams: mapParams,
      dataList: dataList
    });

    return new Promise((resolve, reject)=>{ 
      Request.post(mapUrl, mapParams, res=>{
        if (res.Code>=800){
          Request.setProgress(0)
          resolve(undefined)
        } else {
          resolve(res.Data)
        }
      }, err=>{
        reject(err)
      })
    })
  }
  validNotificateStatus ( checkValidError = true, contract = true,subcon = true ) {
    let valid = true
    if ( checkValidError ) {
      let message = getErrorCodes(this.state.notification.errors)
      if(message.length > 0){
        valid = false;
      }
    }

    const {
      send_setting,
      subcon_send_setting
    }=this.state.notification

    const {
      guide_type: want_guide_type,
      subcon_guide_type: want_guide_type_subcontract,
      fax: fax,
      subcon_fax: subcon_fax
    }=this.state.notification.values

    if ( contract ) {
      // 元請のファックス案内=>ファックスのNULLチェック
      if (send_setting && (want_guide_type == 0 || want_guide_type == 2)) {
        if ( fax && fax.length == 0) { valid = false }
      }
    }
    if ( subcon ) {
      // 元請のファックス案内=>ファックスのNULLチェック
      if (subcon_send_setting && (want_guide_type_subcontract == 0 || want_guide_type_subcontract == 2)) {
        if ( subcon_fax && subcon_fax.length == 0 ) { valid = false }
      }
    }
    return valid;
  }

  getPdf1and2 = async (dataList, processName)=>{

    //    console.log("getPdf1and2",dataList)

    const{
      request_natural_id,
      project_natural_id,
      customer_branch_natural_id,
      customer_user_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      user_branch_natural_id
    } = this.state.request_data

    // 2022-02-22 : QRコードのURLをセット
    let locationOrigin = window.location.origin;
//    let keys = Object.keys(dataList)
    let qr_url = "/api/qrcode?url="
/*
    keys.forEach((k)=>{
      dataList[k] = {
        ...dataList[k],
        ESTIMATE__survey_route_qr_url: locationOrigin + qr_url + encodeURI(dataList[k].ESTIMATE__survey_route_qr_url),
        ESTIMATE__survey_route_zoom_qr_url: locationOrigin + qr_url + encodeURI(dataList[k].ESTIMATE__survey_route_zoom_qr_url),
      }
    })
*/
    const estimate_natural_id_array = await Request.getNaturalId({
      type:"estimate",
      request_natural_id,
      Data:Object.keys(dataList).map((ulid)=>{
        return dataList[ulid]
      })
    })

    for(let i=0; i<Object.keys(dataList).length; i++){
      let keyForUlid = Object.keys(dataList)[i]
      dataList[Object.keys(dataList)[i]].estimate_natural_id=estimate_natural_id_array[i]
      dataList[keyForUlid].ESTIMATE__survey_route_qr_url = locationOrigin + qr_url + encodeURIComponent(dataList[keyForUlid].ESTIMATE__survey_route_qr_url)
      dataList[keyForUlid].ESTIMATE__survey_route_zoom_qr_url = locationOrigin + qr_url + encodeURIComponent(dataList[keyForUlid].ESTIMATE__survey_route_zoom_qr_url)
    }
    
    const Pdf02Process = this.requestEstimateMapPDF(dataList)

    // 調査見積で登録されたデータのエラーが無いこと AND （依頼元担当者のメールアドレスがNullでは無い or FAX番号がNullで無い）
    const PdfResults = Object.keys(dataList).map(async (ulid)=>{
      const estimateData = dataList[ulid]
      const estimateCommonParams = await Request.getEstimateCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        estimateObject: estimateData,
        user_branch_natural_id
      })
      dataList[ulid].estimateCommonParams=estimateCommonParams
      // console.log(estimateData)
      const PdfResult = this.requestEstimatePDF(estimateCommonParams, estimateData)
      // console.log("PdfResult")
      // console.log(PdfResult)
      return PdfResult
    })
    
    
    return await Promise.all([Pdf02Process, ...PdfResults]).catch(
      (err)=>{
      // dispatch a failure and throw error
      console.log('!!ERRORR!! pdf01&02 : ',err)
      Request.setProgress(0)
      if (err.response){
        const {status, statusText} = err.response
        this.props.alertModal.current.showErrorModal({title:status, message:statusText})
      }
      return
    }).then((resolvedData)=>{
//      console.log(resolvedData)
      // 駐車場の見積書兼発注書 最大15見積
      const pdf1 = resolvedData.filter(item => Array.isArray(item))
      // 現場から駐車場までの経路図
      const pdf2 = resolvedData.filter(item => !Array.isArray(item))

      return {
        Pdf01final:pdf1,
        Pdf02final:pdf2[0]
      }
    })
  }

  async getEstimatePDF(){
//    if (this.validate()) {
      Request.setProgress(50, `見積作成中`, GetMessage(2436))
      let dataList = this.validateEstimateDetails(this.getStateToDataForm())
      // 見積書確認の場合、GCSにアプロードしない為なパラメーター
      // dataList[Object.keys(dataList)[0]]["estimate_pdf_check"] = true 
      const keys = Object.keys(dataList);
      keys.forEach(key => {
        dataList[key]["estimate_pdf_check"] = true
      })
      // console.log(dataList)
      const {
        Pdf01final,
        Pdf02final
      } = await this.getPdf1and2(dataList, `見積作成中`)

      // ダイアログを出力
//      console.log('Pdf01final,Pdf02final',Pdf01final,Pdf02final)
      Request.setProgress(0)
      // Pdf02final && window.open(`https://docs.google.com/spreadsheets/d/${Pdf02final.spreadsheet_id}`)

      this.setState({
        Pdf01final: Pdf01final,
        Pdf02final: Pdf02final
      });

      {/** #1873 警告バナー対応 */}
      this.togglePdfRegistModal(true);

//    }
  }

  presave() {
    // TODO 一時保存API呼び出し
    this.togglePresaveModal();
  }

  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";
    }
  }

  copyMaster() {
    this.setState({ copy_data: this.state.data });
  }


  // #1220
  setEstimateMapStateNonedata () {
    return {
      parking_picture_url : "",
      parking_picture_url_thumbnail : "",
      survey_route_picture_url : "",
      survey_route_zoom_picture_url : "",
      survey_route_qr_url : "",
      survey_route_zoom_qr_url : ""
    }
  }

  // 編集等でレコードから取得する値を設定する
  copyEstimate(extend_target_estimate, param_parking_found){
    let copyEstimate = {
      survey_parking_name : extend_target_estimate.survey_parking_name,
      survey_parking_picture_url : extend_target_estimate.survey_parking_picture_url,
      survey_parking_prefecture : extend_target_estimate.survey_parking_prefecture,
      survey_parking_city : extend_target_estimate.survey_parking_city,
      survey_parking_address : extend_target_estimate.survey_parking_address,
      survey_parking_address_contract : extend_target_estimate.survey_parking_address_contract,
      survey_parking_parallel_type : extend_target_estimate.survey_parking_parallel_type,
      survey_capacity_flag_car : extend_target_estimate.survey_capacity_flag_car,
      survey_capacity_flag_light_truck : extend_target_estimate.survey_capacity_flag_light_truck,
      survey_capacity_flag_truck : extend_target_estimate.survey_capacity_flag_truck,
      survey_capacity_flag_other : extend_target_estimate.survey_capacity_flag_other,
      survey_capacity_type_other : extend_target_estimate.survey_capacity_type_other,
      survey_capacity_special_request : extend_target_estimate.survey_capacity_special_request,
      survey_pay_unit_type_day : extend_target_estimate.survey_pay_unit_type_day,
      survey_pay_unit_type_month : extend_target_estimate.survey_pay_unit_type_month,
      supplier_name : extend_target_estimate.supplier_name,
      supplier_name_kana : extend_target_estimate.supplier_name_kana,
      supplier_user_name : extend_target_estimate.supplier_user_name,
      supplier_tel : extend_target_estimate.supplier_tel,
      supplier_tel2 : extend_target_estimate.supplier_tel2,
      supplier_fax : extend_target_estimate.supplier_fax,
      survey_available_start_date : extend_target_estimate.survey_available_start_date,
      survey_available_end_date : extend_target_estimate.survey_available_end_date,
      survey_capacity_qty : extend_target_estimate.survey_capacity_qty,
      survey_capacity_qty_type : extend_target_estimate.survey_capacity_qty_type,
      survey_term_month_flag : extend_target_estimate.survey_term_month_flag,
      survey_cost_parking_rent : extend_target_estimate.survey_cost_parking_rent,
      survey_cost_parking_rent_payment_type : extend_target_estimate.survey_cost_parking_rent_payment_type,
      survey_cost_parking_rent_invoice_business_type : extend_target_estimate.survey_cost_parking_rent_invoice_business_type,
      survey_cost_parking_rent_invoice_registration_number : extend_target_estimate.survey_cost_parking_rent_invoice_registration_number,
      survey_cost_commission_type : extend_target_estimate.survey_cost_commission_type,
      survey_cost_commission_invoice_business_type: extend_target_estimate.survey_cost_commission_invoice_business_type,
      survey_cost_commission_invoice_registration_number: extend_target_estimate.survey_cost_commission_invoice_registration_number,
      survey_cost_commission : extend_target_estimate.survey_cost_commission,
      survey_cost_commission_payment_type : extend_target_estimate.survey_cost_commission_payment_type,
      survey_cost_key_money : extend_target_estimate.survey_cost_key_money,
      survey_cost_key_money_payment_type : extend_target_estimate.survey_cost_key_money_payment_type,
      survey_cost_key_money_invoice_business_type : extend_target_estimate.survey_cost_key_money_invoice_business_type,
      survey_cost_key_money_invoice_registration_number : extend_target_estimate.survey_cost_key_money_invoice_registration_number,
      survey_cost_other : extend_target_estimate.survey_cost_other,
      survey_cost_other_payment_type : extend_target_estimate.survey_cost_other_payment_type,
      survey_cost_other_invoice_business_type : extend_target_estimate.survey_cost_other_invoice_business_type,
      survey_cost_other_invoice_registration_number : extend_target_estimate.survey_cost_other_invoice_registration_number,
      survey_cost_security_deposit : extend_target_estimate.survey_cost_security_deposit,
      survey_parking_rent : extend_target_estimate.survey_parking_rent,
      survey_parking_rent_profit : extend_target_estimate.survey_parking_rent_profit,
      survey_commission : extend_target_estimate.survey_commission,
      survey_commission_discount_rate : extend_target_estimate.survey_commission_discount_rate,
      survey_commission_discount_amt : extend_target_estimate.survey_commission_discount_amt,
      survey_key_money : extend_target_estimate.survey_key_money,
      survey_discount_amt : extend_target_estimate.survey_discount_amt,
      survey_adjustment_amt : extend_target_estimate.survey_adjustment_amt,
      survey_fraction_amt_flag : extend_target_estimate.survey_fraction_amt_flag,
      survey_subtotal_amt : extend_target_estimate.survey_subtotal_amt,
      survey_tax_in_flag : extend_target_estimate.survey_tax_in_flag,
      survey_tax_amt : extend_target_estimate.survey_tax_amt,
      survey_total_amt : extend_target_estimate.survey_total_amt,
      cost_total_amt : extend_target_estimate.survey_cost_total_amt,
      parking_picture_url : extend_target_estimate.parking_picture_url,
      parking_picture_url_thumbnail : extend_target_estimate.parking_picture_url_thumbnail,
      survey_route_picture_url : extend_target_estimate.survey_route_picture_url,
      survey_route_zoom_picture_url : extend_target_estimate.survey_route_zoom_picture_url,
      survey_route_qr_url : extend_target_estimate.survey_route_qr_url,
      survey_route_zoom_qr_url : extend_target_estimate.survey_route_zoom_qr_url,
      original_estimate_natural_id : extend_target_estimate.estimate_natural_id ? extend_target_estimate.estimate_natural_id : undefined,
      ESTIMATE__survey_route_picture_url :  GoogleDrive.getDownloadUrl(extend_target_estimate.survey_route_picture_url),
      ESTIMATE__survey_route_zoom_picture_url : GoogleDrive.getDownloadUrl(extend_target_estimate.survey_route_zoom_picture_url),
      ESTIMATE__survey_route_qr_url : extend_target_estimate.survey_route_qr_url,
      ESTIMATE__survey_route_zoom_qr_url : extend_target_estimate.survey_route_zoom_qr_url,
      ESTIMATE__ulid : extend_target_estimate.ulid,
      ESTIMATE__update_timestamp : extend_target_estimate.update_timestamp,
      cannot_extention_flag: extend_target_estimate.cannot_extention_flag==1?1:0,
      order_memo: extend_target_estimate.order_memo?extend_target_estimate.order_memo:"",
      supplier_memo: extend_target_estimate.supplier_memo?extend_target_estimate.supplier_memo:"",
      survey_site_distance_meter: extend_target_estimate.survey_site_distance_meter,
      survey_site_distance_minute: extend_target_estimate.survey_site_distance_minute,
      estimate_detail_name: extend_target_estimate.estimate_detail_name,
      estimate_detail_amt: extend_target_estimate.estimate_detail_amt,
      estimate_detail_name_ex: extend_target_estimate.estimate_detail_name_ex,
      estimate_detail_amt_ex: extend_target_estimate.estimate_detail_amt_ex,
    };
    if(this.isRouteEdit()) {
      // 経路図編集を経由してきた場合（ルート考慮済みの距離、時間がある場合）距離時間はコピーしない
      console.log("drop survey_site_distance_meter, minute")
      delete copyEstimate.survey_site_distance_meter
      delete copyEstimate.survey_site_distance_minute
    }
    // 編集の場合は、見積期限を引き継ぐ
    if (this.isEdit()) {
      copyEstimate.estimate_expire_date = extend_target_estimate.estimate_expire_date == null ? "":extend_target_estimate.estimate_expire_date;
    }
    return copyEstimate
  }

  mapGestureHandle(parkingNum, param) {
//    console.log(parkingNum, param)
//    console.log(this.state.data)
    let {
      data,
      singleData
    }=this.state
    data[ parkingNum ] = {
      ...data[ parkingNum ],
      map_param: param
    }


    this.setState({
      data : data,
      singleData: {
        ...singleData,
        values : {
          ...singleData.values,
          map_param : param
        }
      },
      syncMapParamters : false
    },()=>{
      //console.log(this.state.data, this.state.singleData
    })
  }

  async onClickedConfirmEstimates () 
  {
    if (this.validate()) {
      if (this.state.syncMapParamters || this.state.copyRouteMapFlag===true) {
        await this.getEstimatePDF()
        return
      }
      let uploadData = await this.createRouteMaps()
      // console.log(uploadData.monochrome_map_url)
      // console.log(uploadData);
      if(uploadData == false){
        this.props.alertModal.current.showErrorModal({
          messageNo:2508 
        }, ()=>{
        })        
        return 
      }
      let {data} = this.state
      let {values} = this.state.singleData
  
      Object.values(uploadData).forEach((newData)=>{
        if (values.keyForRequestParking == newData.keyForRequestParking) {
          values = {
            ...values,
            survey_route_picture_url:newData.survey_route_picture_url,
            ESTIMATE__survey_route_picture_url:newData.ESTIMATE__survey_route_picture_url,
            survey_route_zoom_picture_url: newData.survey_route_zoom_picture_url,
            ESTIMATE__survey_route_zoom_picture_url: newData.ESTIMATE__survey_route_zoom_picture_url,
            survey_route_qr_url: newData.survey_route_qr_url,
            survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
            ESTIMATE__survey_route_qr_url: newData.ESTIMATE__survey_route_qr_url,
            ESTIMATE__survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
          };
        }
        data[newData.keyForRequestParking] = {
          ...data[newData.keyForRequestParking],
          survey_route_picture_url:newData.survey_route_picture_url,
          ESTIMATE__survey_route_picture_url:newData.ESTIMATE__survey_route_picture_url,
          survey_route_zoom_picture_url: newData.survey_route_zoom_picture_url,
          ESTIMATE__survey_route_zoom_picture_url: newData.ESTIMATE__survey_route_zoom_picture_url,
          survey_route_qr_url: newData.survey_route_qr_url,
          survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
          ESTIMATE__survey_route_qr_url: newData.ESTIMATE__survey_route_qr_url,
          ESTIMATE__survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
        }
      })
  
      this.setState({
        data: data,
        singleData: {
          ...this.state.singleData,
          values: values
        },
        syncMapParamters : true,
      },async ()=>{
        await this.getEstimatePDF();
      })
    }
  }

  validateEstimateDetails (data = this.state.data) {
    Object.keys(data).forEach(async (keyForId)=>{
      if ( !data[keyForId].estimate_details ) {
        const {
          survey_term_month_flag,
          survey_capacity_qty,
          survey_parking_rent,
          customer_natural_id,
          request_type,
          survey_tax_in_flag,
          survey_subtotal_amt,
          survey_total_amt,
          survey_available_start_date,
          survey_available_end_date
        } = data[keyForId]
        const endDate = new Date(survey_available_end_date)
        const startDate = new Date(survey_available_start_date)
  
        const {
          monthCount,
          startDays,
          endDays
        } = await this.getCountsFromDuration(startDate, endDate, survey_term_month_flag)
  
        const totalCountForDetails = (startDays?1:0)+(endDays?1:0)+monthCount
      // const incrementalMonthCount = totalCountForDetails>11?2:1
      const incrementalMonthCount = Math.ceil(totalCountForDetails/11)
      // console.log(incrementalMonthCount)
      
        const estimate_details = this.createEstimateDetails({
          monthCount, //
          survey_capacity_qty,
          startDate,  //
          startDays, //
          survey_parking_rent,
          endDays, // 
          endDate, // 
          incrementalMonthCount,
          customer_natural_id,
          survey_term_month_flag,
          request_type,
          survey_tax_in_flag,
          survey_subtotal_amt,
          survey_total_amt
        })
        data[keyForId] = {
          ...data[keyForId],
          estimate_details: estimate_details
        }
      }
    })
    return data
  }

  // 見積送付(廃止　送付機能は別に移すので移すまで保全)
  async onClickedSendEstimates () 
  {
    // 全ての見積の情報を入力したか確認
    //見積件数
    if (this.state.copyRouteMapFlag == false) {
      const estimateCount = Object.keys(this.state.data);
      if(estimateCount.length > this.state.doneEstimate.length){
        this.props.alertModal.current.showErrorModal({messageNo:2493})
        return;
      }
    }
    if(this.validate()){
      if ( this.validNotificateStatus() === false ) {
        let message = getErrorCodes(this.state.notification.errors)
        if(message.length > 0){
          this.props.alertModal.current.showErrorModal({messageNo:message})
          return false
        }
        this.props.alertModal.current.showErrorModal({messageNo:"2024",message:message});
        return false;
      }

      if (this.state.syncMapParamters || this.state.copyRouteMapFlag===true) {
        this.sendEstimates()
        return
      }

      let uploadData = await this.createRouteMaps()
      if(uploadData == false){
        this.props.alertModal.current.showErrorModal({
          messageNo:2508 
        }, ()=>{
        })        

        return ;
      }

      let {data} = this.state
      let {values} = this.state.singleData

      Object.values(uploadData).forEach((newData)=>{
        if (values.keyForRequestParking == newData.keyForRequestParking) {
          values = {
            ...values,
            survey_route_picture_url:newData.survey_route_picture_url,
            ESTIMATE__survey_route_picture_url:newData.ESTIMATE__survey_route_picture_url,
            survey_route_zoom_picture_url: newData.survey_route_zoom_picture_url,
            ESTIMATE__survey_route_zoom_picture_url: newData.ESTIMATE__survey_route_zoom_picture_url,
            survey_route_qr_url: newData.survey_route_qr_url,
            survey_route_zoom_qr_url: newData.survey_route_zoom_qr_url,
            ESTIMATE__survey_route_qr_url: newData.ESTIMATE__survey_route_qr_url,
            ESTIMATE__survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
          };
        }
        data[newData.keyForRequestParking] = {
          ...data[newData.keyForRequestParking],
          survey_route_picture_url:newData.survey_route_picture_url,
          ESTIMATE__survey_route_picture_url:newData.ESTIMATE__survey_route_picture_url,
          survey_route_zoom_picture_url: newData.survey_route_zoom_picture_url,
          ESTIMATE__survey_route_zoom_picture_url: newData.ESTIMATE__survey_route_zoom_picture_url,
          survey_route_qr_url: newData.survey_route_qr_url,
          survey_route_zoom_qr_url: newData.survey_route_zoom_qr_url,
          ESTIMATE__survey_route_qr_url: newData.ESTIMATE__survey_route_qr_url,
          ESTIMATE__survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
        }
      })

      this.setState({
        data: data,
        singleData: {
          ...this.state.singleData,
          values: values
        },
        syncMapParamters : true
      },()=>{
        this.toggleRegistModal()
      })
    }
  }

  define_subtotal () {
    let {
      request_type,
      survey_subtotal_amt,
      estimate_detail_amt,
      estimate_detail_amt_ex,
      survey_subtotal_amt_without_estimate_detail_amt_ex,
      fraction_adjustmented_estimate_detail_amt_ex
    } = this.state.singleData.values
    let _survey_subtotal_amt = survey_subtotal_amt;
    let elem = (Format.format_number_with_commas(_survey_subtotal_amt)+"円")
    + "（課税項目小計：" + Format.format_number_with_commas(survey_subtotal_amt_without_estimate_detail_amt_ex) + "円，"
    + "非課税項目小計：" + Format.format_number_with_commas(fraction_adjustmented_estimate_detail_amt_ex) + "円）"    
    return(<>{elem}</>)
  }

  // モーダルを表示する
  sendEstimates () {
      // 全ての見積の情報を入力したか確認
      //見積件数
/*
      if (this.state.copyRouteMapFlag == false) {
        const estimateCount = Object.keys(this.state.data);
        if(estimateCount.length > this.state.doneEstimate.length){
          this.props.alertModal.current.showErrorModal({messageNo:2493})
          return;
        }
      }
*/
      if(this.validate()){
        if ( this.validNotificateStatus() === false ) {
          let message = getErrorCodes(this.state.notification.errors)
          if(message.length > 0){
            this.props.alertModal.current.showErrorModal({messageNo:message})
            return false
          }
          this.props.alertModal.current.showErrorModal({messageNo:"2024",message:message});
          return false;
        }
        this.toggleRegistModal();
      }
  }

  render() {
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.request_data)
    const {survey_cost_parking_rent, survey_cost_commission, survey_cost_key_money, survey_cost_other} = this.state.singleData.values
    return (
      <>
        <div className="content" ref={this.pageDiv}>
          <Row>
            <Col md="12">
              <Card>
                <Row>
                  <Col md="8">
                    <CardHeader><CardTitle tag="h3" className="float-left">見積登録</CardTitle></CardHeader>
                  </Col>
                  <Col md="4" style={{paddingTop:'25px'}}>
                    <Row>
                      <Col>
                        <h5>案件ID：{this.state.singleData.values.request_natural_id}</h5>
                      </Col>
                    </Row>
                    <Row><Col>
                      <h5>現場名：{this.state.singleData.values.site_name}</h5>
                    </Col></Row>
                  </Col>
                </Row>
                <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">管理情報</CardTitle>
                    </CardHeader>
                </Col>
                <Col md="12" className="detail">
                  <Table>
                    <tbody>
                    <tr>
                      <CustomTd label='顧客マスタメモ'
                          name='CUSTOMER__customer_system_memo'
                          colSpan="4"
                          copy={false}
                          value={this.state.singleData.values.customer_system_memo}
                      />
                      </tr>                      
                      <tr>
                      <CustomTd label='顧客支店メモ'
                          name='CUSTOMER_BRANCH__customer_branch_system_memo'
                          colSpan="4"
                          copy={false}
                          value={this.state.singleData.values.customer_branch_system_memo}
                      />
                      </tr>
                      <tr>
                      <CustomTd label='顧客担当者メモ'
                          name='CUSTOMER_USER__customer_user_system_memo'
                          colSpan="4"
                          copy={false}
                          value={this.state.singleData.values.customer_user_system_memo}
                      />
                      </tr>                      
                      <tr>
                      <CustomTd label='顧客要望'
                          name='ESTIMATE__survey_commission_discount_amt'
                          colSpan="4"
                          copy={false}
                          value={this.state.singleData.values.customer_other_request}
                      />
                      </tr>
                      <tr>
                      <CustomTd label='顧客メモ'
                          name='ESTIMATE__order_memo'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <Input
                              type={"textarea"}
                              value={this.state.singleData.values.order_memo}
                              onClick={() => { this.memoPopupAction(true) }}
                            />
                          }
                      />
                      </tr>
                      <tr>
                      <CustomTd label='仕入先メモ'
                          name='ESTIMATE__supplier_memo'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <Input
                              type={"textarea"}
                              value={this.state.singleData.values.supplier_memo}
                              onClick={() => { this.memoPopupAction(false); }}
                            />
                          }
                      />
                      </tr>
                      {this.state.singleData.values.auto_order_display_flag == 1 && this.state.request_data.auto_order_function_flag == 1 &&
                      <tr>
                        <CustomTd label='自動発注実行'
                            name='REQUEST__auto_order_execution_flag'
                            colSpan="4"
                            copy={false}
                            rootData={this.state.request_data}
                            value={
                              <InputRadio
                                options={cst_auto_order_execution_flag}
                                validateCallback={this.validateAutoOrderCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      }
                  </tbody>
                  </Table>
                  {this.state.singleData.values.auto_order_display_flag == 1 && this.state.request_data.auto_order_function_flag == 1 &&
                  <font color="red">※自動発注機能を利用する案件となっています</font>
                  }
                </Col>
                <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">調査担当者</CardTitle>
                    </CardHeader>
                </Col>
                <Col md="12" className="detail">
                  <Table>
                    <tbody>
                      <tr>
                        <CustomTd label='調査担当者'
                            name='REQUEST__web_survey_account'
                            colSpan="4"
                            copy={false}
                            rootData={this.state.survey_data}
                            value={
                              <InputSelect
                                options={this.state.landmark_user}
                                validateCallback={this.validateSurveyCallback}
                                isSearchable={true}
                                isNull={true}
                                validateType="regist" 
                              />
                            }
                        />
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                {/* #1034 送信先FAX、メールアドレスを設定 */}
                {this.renderSendSetting()}
                {/* #1034 ここまで */}
                <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">駐車場情報</CardTitle>
                    </CardHeader>
                </Col>
                <Col md="12" className="detail">
                  <Table><tbody>
                    <tr>
                      {/* <th rowSpan="2"></th> */}
                      {/* <th rowSpan="2">駐車場名</th> */}
                      <CustomTd label='駐車場名'
                          colSpan="4"
                          name='ESTIMATE__survey_parking_name'
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                        <td className="subTitle">写真</td>
                        <td colSpan="3" style={{ position: "relative" }}>
                          <Images
                          {...this.props}
                            ref={this.images}
                            editable={true}
                            name='ESTIMATE__survey_parking_picture_url'
                            rootData={this.state.singleData}
                            uploadCallback={this.uploadImageCallback}
                            image_items={this.state.singleData.values.parking_pictures || []}
                            imageFolderId={this.state.singleData.values.parking_picture_url}
                            defaultCheckedImage={this.state.singleData.values.survey_parking_picture_url}
                            selectable={true} />
                            {this.state.singleData.errors.survey_parking_picture_url
                              && <p id="ESTIMATE__survey_parking_city" style={{color: "red"}}>
                              {this.state.singleData.errors.survey_parking_picture_url}
                            </p>}
                        </td>
                      </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">駐車場所在地</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="3">駐車場所在地</th> */}
                      <CustomTd label='都道府県'
                          name='ESTIMATE__survey_parking_prefecture'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputSelect
                              options={cst_prefecture}
                              validateCallback={this.validateCallback}
                              rootData={this.state.data} 
                              isSearchable={true}
                              isNull={true}
                              validateType="regist" 
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='市区町村'
                          name='ESTIMATE__survey_parking_city'
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                      <CustomTd label='番地'
                          name='ESTIMATE__survey_parking_address'
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='土地の地番（契約書記載の所在地）'
                          name='ESTIMATE__survey_parking_address_contract'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  {/* 経路図詳細  編集中　ここから*/}
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">経路図</CardTitle>
                    </CardHeader>
                  </Col>
                  {this.state.singleData.values &&
                   this.state.singleData.values.latitude && (<>
                    <Col md="12" className="detail">
                    {/** 経路図編集から遷移した場合の見積編集は操作加*/}
                      {(this.state.copyRouteMapFlag || !this.isMapZoom ) ?(<p class="image-filter">
                        <p class="blur-text">拡大図の編集はできません</p>
                        <img style={{width:"1280px",height:"1200px"}} src={GoogleDrive.getDownloadUrl(this.state.singleData.values.survey_route_zoom_picture_url)} alt="googlestaticmap" />
                      </p>):(<>
                        <DetailMap 
                          start={{lat:this.state.request_data.latitude, lng:this.state.request_data.longitude}}
                          parkingData={this.state.parkings}
                          basemapData={this.props.location.state.map_objects}
                          flaggedParkings={this.props.location.state.flagged_pakings?this.props.location.state.flagged_pakings: []}
                          requestNumber={this.state.singleData.values.keyForRequestParking}
                          callbackGesture={(num, param)=>this.mapGestureHandle(num, param)}
                        />
                      </>)}
                    </Col>
                  </>)}
                  {/* 経路図詳細 編集中　ここまで*/}
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">駐車場確認項目</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th>駐車場確認項目</th> */}
                      <CustomTd label='駐車方法'
                          name='ESTIMATE__survey_parking_parallel_type'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputRadio
                              options={cst_parking_parallel_type}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">車両制限</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="3">車両制限</th> */}
                      <CustomTd 
                        label="収容可能車種" 
                        colSpan="4"
                        copy={false}
                        value={
                        <>
                          <InputCheckBox label="ワゴン車"
                            name="ESTIMATE__survey_capacity_flag_car" 
                            validateCallback={this.validateCallback} 
                            checkedValue={1}
                            uncheckedValue={0}
                            rootData={this.state.singleData}
                            />
                          <InputCheckBox label="軽トラック"
                            name="ESTIMATE__survey_capacity_flag_light_truck" 
                            validateCallback={this.validateCallback} 
                            checkedValue={1}
                            uncheckedValue={0}
                            rootData={this.state.singleData}
                            />
                          <InputCheckBox label="2tトラック"
                            name="ESTIMATE__survey_capacity_flag_truck" 
                            validateCallback={this.validateCallback} 
                            checkedValue={1}
                            uncheckedValue={0}
                            rootData={this.state.singleData}
                            />
                          <InputCheckBox label="その他"
                            name="ESTIMATE__survey_capacity_flag_other" 
                            validateCallback={this.validateCallback} 
                            checkedValue={1}
                            uncheckedValue={0}
                            rootData={this.state.singleData}
                            />
                        </>
                      }/>
                    </tr>
                    <tr>
                      <CustomTd label='その他詳細'
                          name='ESTIMATE__survey_capacity_type_other'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='特別条件'
                          name='ESTIMATE__survey_capacity_special_request'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              multiline={true}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">日割条件</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      <CustomTd label='日割可否'
                          name='ESTIMATE__survey_pay_unit_type_day'
                          copy={false}
                          rootData={this.state.singleData}
                          colSpan="4"
                          value={
                            <InputRadio
                              options={cst_pay_unit_type_day}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      {/* <th rowSpan="2">利用可能期間</th> */}
                      <CustomTd label='通し可否'
                          name='ESTIMATE__survey_pay_unit_type_month'
                          copy={false}
                          colSpan="4"
                          rootData={this.state.singleData}
                          value={
                            <InputRadio
                              options={cst_pay_unit_type_month}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">仕入先情報</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="6">仕入先情報</th> */}
                      <CustomTd label='仕入先名'
                          name='ESTIMATE__supplier_name'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              hasKanaInput={true}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='仕入先名（カナ）'
                          name='ESTIMATE__supplier_name_kana'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='仕入先担当者名'
                          name='ESTIMATE__supplier_user_name'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='電話番号1'
                          name='ESTIMATE__supplier_tel'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='電話番号2'
                          name='ESTIMATE__supplier_tel2'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='FAX番号'
                          name='ESTIMATE__supplier_fax'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">見積情報</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="6">見積情報</th> */}
                      <CustomTd label='見積期間：開始日'
                          name='ESTIMATE__survey_available_start_date'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputDatetime
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={this.state.singleData.values.request_type=="2"}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='見積期間：終了日'
                          name='ESTIMATE__survey_available_end_date'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputDatetime
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>

                    <CustomTd 
                        label="延長不可フラグ" 
                        colSpan="4"
                        copy={false}
                        tdBackgroundColor ='subTitle-orange'
                        value={
                          <InputCheckBox label="延長不可フラグ"
                            name="ESTIMATE__cannot_extention_flag" 
                            validateCallback={this.validateCallback} 
                            checkedValue={1}
                            uncheckedValue={0}
                            rootData={this.state.singleData}
                            />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='見積台数'
                          name='ESTIMATE__survey_capacity_qty'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              unit={FormatCode.decode("cst_survey_capacity_qty_type", this.state.singleData.values.survey_capacity_qty_type)}
                            />
                          }
                      />
                      <CustomTd label='駐車場空台数'
                          name='REQUEST_PARKING__request_parking_space_qty'
                          copy={false}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            this.state.singleData.values.request_parking_space_qty+FormatCode.decode("cst_survey_capacity_qty_type", this.state.singleData.values.survey_capacity_qty_type)
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='単位'
                          name='ESTIMATE__survey_capacity_qty_type'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputRadio
                              options={cst_survey_capacity_qty_type}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='現場距離（分）'
                          colSpan="4"
                          copy={false}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            Format.disp_time(parseInt(this.state.singleData.values.survey_site_distance_meter),this.state.singleData.values.request_type)
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='現場距離（メートル）'
                          colSpan="4"
                          copy={false}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            Format.comma_delimited(parseInt(this.state.singleData.values.survey_site_distance_meter),"m")
                          }
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">計算方法</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="2">計算方法</th> */}
                      <CustomTd label='通し有無'
                          name='ESTIMATE__survey_term_month_flag'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputRadio
                              disabled={undefined}
                              options={cst_term_month_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                      <CustomTd label='実質月数'
                          name='___CAL_month_qty'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={(this.state.singleData.values._CAL_month_qty === "" || 
                            (this.state.singleData.errors.survey_term_alert && this.state.singleData.errors.survey_term_alert[1].notIgnore)
                          ? "" : (this.state.singleData.values._CAL_month_qty + "ヶ月"))}
                      />
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <div
                          style={{color:"red"}}
                        >
                          {this.state.singleData.errors.survey_term_alert && this.state.singleData.errors.survey_term_alert[0]}
                        </div>
                      </td>
                      <CustomTd label='実質日数'
                          name='___CAL_day_qty'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={ (this.state.singleData.errors.survey_term_alert && this.state.singleData.errors.survey_term_alert[1].notIgnore) 
                            ? "" : this.state.singleData.values._CAL_day_qty}
                      />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">仕入金額</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="7">仕入金額</th> */}
                      <CustomTd label='賃料（月単価）'
                          colSpan="12"
                          copy={false}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <Row>
                              <Col md="4">
                                <InputNumber
                                  name='ESTIMATE__survey_cost_parking_rent'
                                  rootData={this.state.singleData}
                                  size={10}
                                  unit="円"
                                  disabled={undefined}
                                  validateCallback={this.validateCallback} 
                                  validateType='regist'
                                />
                              </Col>
                              <Col md="8">
                                <div style={{display:"inline-flex", flexDirection:"column"}}>
                                  <InputInvoice
                                    label={""}
                                    labelOn={true}
                                    names={{
                                      payment_type: "ESTIMATE__survey_cost_parking_rent_payment_type",
                                      business_type: "ESTIMATE__survey_cost_parking_rent_invoice_business_type",
                                      registration_number: "ESTIMATE__survey_cost_parking_rent_invoice_registration_number",
                                      with_unconfirmed: "ESTIMATE__survey_cost_parking_rent_invoice_business_type"
                                    }}
                                    rootData={this.state.singleData}
                                    validateCallback={this.validateCallback}
                                    visible={true}
                                    viewUntax={true}
                                    // disabled={request_type == 3 ? quote_cost_total_amt <= 0 : survey_cost_parking_rent <= 0}
                                    disabled={survey_cost_parking_rent <= 0}
                                  />
                                  {this.state.singleData.errors.survey_cost_parking_rent_payment_type ? <p style={{ color: "red" }}>{this.state.singleData.errors.survey_cost_parking_rent_payment_type}</p> : ""}
                                </div>
                              </Col>
                            </Row>
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='手数料計算方法'
                          name='ESTIMATE__survey_cost_commission_type'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputRadio
                              disabled={undefined}
                              options={cst_commission_type}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='手数料'
                          colSpan="4"
                          copy={false}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <Row>
                              <Col md="4">
                                <InputNumber
                                  name='ESTIMATE__survey_cost_commission'
                                  rootData={this.state.singleData}
                                  size={10}
                                  unit="円"
                                  validateCallback={this.validateCallback} 
                                  validateType='regist'
                                  disabled={undefined}
                                />
                              </Col>
                              <Col md="8">
                                <div style={{display:"inline-flex", flexDirection:"column"}}>
                                  <InputInvoice
                                    label={""}
                                    labelOn={true}
                                    names={{
                                      payment_type: "ESTIMATE__survey_cost_commission_payment_type",
                                      business_type: "ESTIMATE__survey_cost_commission_invoice_business_type",
                                      registration_number: "ESTIMATE__survey_cost_commission_invoice_registration_number",
                                      with_unconfirmed: "ESTIMATE__survey_cost_commission_invoice_business_type"
                                    }}
                                    rootData={this.state.singleData}
                                    validateCallback={this.validateCallback}
                                    visible={true}
                                    viewUntax={true}
                                    // disabled={request_type == 3 ? quote_cost_total_amt <= 0 : survey_cost_parking_rent <= 0}
                                    disabled={survey_cost_commission <= 0}
                                  />
                                  {this.state.singleData.errors.survey_cost_commission_payment_type ? <p style={{ color: "red" }}>{this.state.singleData.errors.survey_cost_commission_payment_type}</p> : ""}

                                </div>
                              </Col>
                            </Row>
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='礼金'
                          copy={false}
                          colSpan="4"
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <Row>
                              <Col md="4">
                                <InputNumber
                                  name='ESTIMATE__survey_cost_key_money'
                                  rootData={this.state.singleData}
                                  size={10}
                                  unit="円"
                                  validateCallback={this.validateCallback} 
                                  validateType='regist'
                                  disabled={undefined}
                                />
                              </Col>
                              <Col md="8">
                                <div style={{display:"inline-flex", flexDirection:"column"}}>
                                  <InputInvoice
                                    label={""}
                                    labelOn={true}
                                    names={{
                                      payment_type: "ESTIMATE__survey_cost_key_money_payment_type",
                                      business_type: "ESTIMATE__survey_cost_key_money_invoice_business_type",
                                      registration_number: "ESTIMATE__survey_cost_key_money_invoice_registration_number",
                                      with_unconfirmed: "ESTIMATE__survey_cost_key_money_invoice_business_type"
                                    }}
                                    rootData={this.state.singleData}
                                    validateCallback={this.validateCallback}
                                    visible={true}
                                    viewUntax={true}
                                    // disabled={request_type == 3 ? quote_cost_total_amt <= 0 : survey_cost_parking_rent <= 0}
                                    disabled={survey_cost_key_money <= 0}
                                  />
                                  {this.state.singleData.errors.survey_cost_key_money_payment_type ? <p style={{ color: "red" }}>{this.state.singleData.errors.survey_cost_key_money_payment_type}</p> : ""}
                                </div>
                              </Col>
                            </Row>
                          }
                      />
                    </tr>
                     <tr>
                      <CustomTd label='その他'
                          copy={false}
                          colSpan="4"
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <Row>
                              <Col md="4">
                                <InputNumber
                                  name='ESTIMATE__survey_cost_other'
                                  rootData={this.state.singleData}
                                  size={10}
                                  unit="円"
                                  validateCallback={this.validateCallback} 
                                  validateType='regist'
                                  disabled={undefined}
                                />
                              </Col>
                              <Col md="8">
                                <div style={{display:"inline-flex", flexDirection:"column"}}>
                                  <InputInvoice
                                    label={""}
                                    labelOn={true}
                                    names={{
                                      payment_type: "ESTIMATE__survey_cost_other_payment_type",
                                      business_type: "ESTIMATE__survey_cost_other_invoice_business_type",
                                      registration_number: "ESTIMATE__survey_cost_other_invoice_registration_number",
                                      with_unconfirmed: "ESTIMATE__survey_cost_other_invoice_business_type"
                                    }}
                                    rootData={this.state.singleData}
                                    validateCallback={this.validateCallback}
                                    visible={true}
                                    viewUntax={true}
                                    // disabled={request_type == 3 ? quote_cost_total_amt <= 0 : survey_cost_parking_rent <= 0}
                                    disabled={survey_cost_other <= 0}
                                  />
                                  {this.state.singleData.errors.survey_cost_other_payment_type ? <p style={{ color: "red" }}>{this.state.singleData.errors.survey_cost_other_payment_type}</p> : ""}
                                </div>
                              </Col>
                            </Row>
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='仕入合計'
                          copy={false}
                          colSpan="4"
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            Format.format_number_with_commas(this.state.singleData.values._CAL_cost_total_amt)+"円"
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='敷金'
                          name='ESTIMATE__survey_cost_security_deposit'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={undefined}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='敷金合計'
                          name='___CAL_cost_security_deposit_total_amt'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={Format.format_number_with_commas(this.state.singleData.values._CAL_cost_security_deposit_total_amt)+"円"}
                        />
                    </tr>
                    </tbody>
                    </Table>
                  </Col>
                  <Col md="8">
                    <CardHeader>
                      <CardTitle tag="h4" className="float-left">見積金額</CardTitle>
                    </CardHeader>
                  </Col>
                  <Col md="12" className="detail">
                    <Table><tbody>
                    <tr>
                      {/* <th rowSpan="12">見積金額</th> */}
                      <CustomTd label={'賃料（月単価）'}
                          name={'ESTIMATE__survey_parking_rent'}
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              // disabled={this.state.singleData.values.request_type=="3"?true:undefined}
                            />
                          }
                      />
                      <CustomTd
                        label="上乗せ額：賃料（月単価）"
                        name='ESTIMATE__survey_parking_rent_profit'
                        copy={false}
                        rootData={this.state.singleData}
                        tdBackgroundColor ='subTitle-orange'
                        value={Format.comma_delimited(this.state.singleData.values.survey_parking_rent_profit, "円")}
                        error={this.state.singleData.errors.survey_parking_rent_profit_alert}
                      />
                    </tr>
                    <tr>
                      <CustomTd label='手数料'
                          name='ESTIMATE__survey_commission'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={undefined}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='手数料割引率（%）'
                          name='ESTIMATE__survey_commission_discount_rate'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="%"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={(this.state.singleData.values.request_type=="2")?true:undefined}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='実質手数料'
                          name='ESTIMATE__survey_commission_discount_amt'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={Format.format_number_with_commas(this.state.singleData.values.survey_commission_discount_amt)+"円"}
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="礼金"
                        name="ESTIMATE__survey_key_money"
                        colSpan="4"
                        copy={false}
                        rootData={this.state.singleData}
                        tdBackgroundColor ='subTitle-orange'
                        value={
                          <InputNumber
                            unit="円"
                            validateCallback={this.validateCallback} 
                            validateType="regist"
                            disabled={undefined}
                            />
                        }/>
                    </tr>
                    <tr>
                      <CustomTd label='調整（値引）'
                          name='ESTIMATE__survey_discount_amt'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              maximum="0"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={(this.state.singleData.values.request_type=="2")?true:undefined}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='調整金額（実費用）'
                          name='ESTIMATE__survey_adjustment_amt'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={undefined}
                            />
                          }
                      />
                    </tr>
                    {/**2023/07/26 feature/1455不具合対応 */}
                    <tr>
                      <CustomTd label='その他課税項目名'
                          name='ESTIMATE_DETAIL__estimate_detail_name'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={false}
                            />
                          }
                      />
                      <CustomTd label='その他課税金額'
                          name='ESTIMATE_DETAIL__estimate_detail_amt'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='その他非課税項目名'
                          name='ESTIMATE_DETAIL__estimate_detail_name_ex'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={false}
                            />
                          }
                      />
                      <CustomTd label='その他非課税金額'
                          name='ESTIMATE_DETAIL__estimate_detail_amt_ex'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputNumber
                              unit="円"
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='端数調整'
                          name='ESTIMATE__survey_fraction_amt_flag'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            <InputRadio
                              options={cst_fraction_amt_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={undefined}
                            />
                          }
                      />
                    </tr>

                    <tr>
                      <CustomTd label='見積小計'
                          name='ESTIMATE__survey_subtotal_amt'
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                              (this.define_subtotal())
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="税" 
                        colSpan="4"
                        copy={false}
                        tdBackgroundColor ='subTitle-orange'
                        value={
                          <InputRadio options={cst_tax_in_flag}
                            validateCallback={this.validateCallback} 
                            rootData={this.state.singleData}
                            validateType="regist"
                            label="税"
                            name="ESTIMATE__survey_tax_in_flag"
                            />
                        }/>
                    </tr>
                    <tr>
                      <CustomTd label='税額'
                          name='ESTIMATE__survey_tax_amt'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={Format.format_number_with_commas(this.state.singleData.values.survey_tax_amt)+"円"}
                        />
                    </tr>
                    
                    <tr>
                      <CustomTd label='見積合計'
                          name='ESTIMATE__survey_total_amt'
                          colSpan="4"
                          copy={false}
                          rootData={this.state.singleData}
                          tdBackgroundColor ='subTitle-orange'
                          value={
                            Format.format_number_with_commas(this.state.singleData.values.survey_total_amt)+"円"
                          }
                      />
                    </tr>
                  </tbody></Table>
                  <Row>
                    <Col md="9"></Col>
                    <Col md="3">
                    <InputCheckBox 
                    label="エラーを無視する"
                    name="TEMP__ignore_error" 
                    validateCallback={this.validateCallback} 
                    checkedValue={1}
                    uncheckedValue={0}
                    rootData={this.state.singleData}
                    />
                    </Col>
                  </Row>
                </Col>
                <Container>
                  <Row>
                    <Col md="3">
                      <h5 >仕入合計： {Format.format_number_with_commas(this.state.singleData.values._CAL_cost_total_amt)+"円"}</h5>
                      <h5 >見積合計： { Format.format_number_with_commas(this.state.singleData.values.survey_total_amt)+"円"}</h5>
                      
                    </Col>
                    <Col md="3">
                      <h5>利益額：
                        { Format.format_number_with_commas(this.state.singleData.values._CAL_profit_amt)+"円" } 
                        <span style={{color:"red"}}>
                          {this.state.singleData.errors._CAL_profit_amt?this.state.singleData.errors._CAL_profit_amt[0]:""}
                        </span>
                      </h5>
                      <h5>利益率： {this.state.singleData.values._CAL_profit_rate + "%"}</h5>
                    </Col>
                    <Col md="3">
                      <span style={{color:"red"}}>
                      {(this.state.singleData.values._CAL_survey_parking_rent_rate25 || this.state.singleData.values._CAL_survey_commission_rate25 ?
                        ("利益率25%まで" +
                          (this.state.singleData.values._CAL_survey_parking_rent_rate25 ? ("賃料" + Format.format_number_with_commas(this.state.singleData.values._CAL_survey_parking_rent_rate25) + "円") : "") +
                          (this.state.singleData.values._CAL_survey_commission_rate25 ? ("手数料" + Format.format_number_with_commas(this.state.singleData.values._CAL_survey_commission_rate25) + "円") : "") +
                          "足りません。") : "")}<br />
                      </span>
                      <span style={{color:"red"}}>
                        {this.state.singleData.errors.survey_commission_amount && (<>
                          {this.state.singleData.errors.survey_commission_amount[0]}
                        </>)}
                      </span>
                    </Col>
                  </Row>
                </Container>
                <Container>
                  <Row>
                    <Col md="3">
                      <Button color="secondary" onClick={() => { 
                      //  this.props.history.push("/survey/detail/"+this.state.requestUlid) 
                      this.props.history.goBack()
                      }}>
                        {this.state.copyRouteMapFlag?"調査一覧に戻る":"経路図に戻る"}
                      </Button>
                    </Col>
                    {this.isEdit()?<>
                    <Col md="3"><ButtonWithRole
                        button_id="BTN_C2_01_01761"
                        color="primary" 
                        onClick={ () => {this.onClickedConfirmEstimates();}}>
                          見積書確認
                        </ButtonWithRole>
                    </Col>
                    </>:<>
                    <Col md="3"><ButtonWithRole
                        button_id="BTN_C2_01_01761"
                        disabled={Boolean(this.state.next_ulid)}
                        color="primary" 
                        onClick={ () => {this.onClickedConfirmEstimates();}}>
                          見積書確認
                        </ButtonWithRole>
                    </Col>
                    </>}
                    <Col md="3">
                      <Button
                        className={"secondary"+ (this.state.next_ulid?'':" disabled")}
                        onClick={()=>{
                          if(this.validate() && this.state.next_ulid){
                            this.setSingleDatum(this.state.next_ulid);
                            this.pageDiv.current.scrollIntoView();
                          }
                        }}>
                        次の見積登録へ
                      </Button>
                    </Col>
                    <Col md="3">{this.state.parkings.map((parking,index)=>{
                      const key = parking.request_parking_ulid
                      const textDecoration  =  (this.state.current_ulid == key) ? 'underline': ''
                      return <span key={index} className={"badge badge-fill "+((this.state.current_ulid == key) ? 'badge-warning': 'badge-info')}
                        style={{float: 'none', cursor:'pointer', textDecoration}}
                        onClick={()=>{
                          if(this.validate() && (this.state.current_ulid != key)){
                            this.setSingleDatum(key)}
                          }}>
                          {(index+1)}
                      </span>
                    })}
                    </Col>
{/*
                    <Col md="3">{Object.keys(this.state.data).map((key,index)=>{
                      const textDecoration  =  (this.state.current_ulid == key) ? 'underline': ''
                      return <span key={index} className={"badge badge-fill "+((this.state.current_ulid == key) ? 'badge-warning': 'badge-info')}
                        style={{cursor:'pointer', textDecoration}}
                        onClick={()=>{
                          if(this.validate() && (this.state.current_ulid != key)){
                            this.setSingleDatum(key)}
                          }}>
                          {(index+1)}
                      </span>
                    })}
                    </Col>
  */}
                  </Row>
                  <Row>
                    <Col md="7"></Col>
                    <Col md="5">
                      {!this.state.next_ulid && !this.isEdit() &&
                      <ButtonWithRole 
                        button_id="BTN_C2_01_01790"
                        color="secondary" 
                        onClick={()=>{
                          this.onClickedSendEstimates()
                        }}
                      >
                        見積作成
                      </ButtonWithRole>}
                      {this.isEdit() &&
                      <ButtonWithRole 
                        button_id="BTN_C2_01_01790"
                        color="secondary" 
                        onClick={()=>{
                          this.onClickedSendEstimates()
                        }}
                      >
                        見積更新
                      </ButtonWithRole>}
                    </Col>
                  </Row>
                </Container>
              </Card>
            </Col>
          </Row>
        </div>

        {/** 廃止予定 送信モーダル 
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>調査見積を送付します。よろしいですか</p>
            { <FormControlLabel
              control={<Switch checked={this.state.isToSend} onChange={()=>this.setState({isToSend:!this.state.isToSend})} value={false} />}
              label="送信せず完了する"
            /> }
            <InputDatetime
              label="見積有効期限日"
              labelOn={true}
              name="ESTIMATE__estimate_expire_date" 
              validateCallback={this.validateCallback} 
              validateType='regist'
              rootData={this.state.singleData}
            />
            <InputCheckBox 
              label="FAXを自動送信しない"
              name="TEMP__no_send_fax" 
              validateCallback={this.validateCallback} 
              checkedValue={true}
              uncheckedValue={false}
              rootData={this.state.singleData}
            />
            <br />
            <InputCheckBox 
              label="調査見積書通知を送る"
              name="NODB__send_upload_notification" 
              validateCallback={this.validateCallback} 
              checkedValue={true}
              uncheckedValue={false}
              rootData={this.state.singleData}
              disabled={!Boolean(this.state.singleData.values.customer_system_use_flag)}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ1
            </Button>
            <ButtonWithRole 
              button_id="BTN_C2_01_01820" 
              color="info" 
              onClick={() => { 
                if(this.validate(true)){
                  this.toggleRegistModal(); 
                  this.regist();
                  this.toggleRegistModal(); 
                  this.toggleSubRegistModal(); 
                }
              }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
         見積保存モーダル */}
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>調査見積を作成します。よろしいですか</p>
            {/* <FormControlLabel
              control={<Switch checked={this.state.isToSend} onChange={()=>this.setState({isToSend:!this.state.isToSend})} value={false} />}
              label="送信せず完了する"
            /> */}
            <InputDatetime
              label="見積有効期限日"
              labelOn={true}
              name="ESTIMATE__estimate_expire_date" 
              validateCallback={this.validateCallback} 
              validateType='regist'
              rootData={this.state.singleData}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              button_id="BTN_C2_01_01820" 
              color="info" 
              onClick={() => { 
                if(this.validate(true)){
                  this.toggleRegistModal(); 
                  this.regist();
                  this.toggleRegistModal(); 
                  this.toggleSubRegistModal(); 
                }
              }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.update_modal} toggle={this.toggleUpdateModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleUpdateModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">更新しますか？</h5>
          </div>
          <ModalBody>
            <p>更新しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleUpdateModal}>
              いいえ
         </Button>
            <Button color="info" onClick={() => { this.toggleUpdateModal(); }}>
              はい
         </Button>
          </ModalFooter>
        </Modal>
        {/** 仕入先メモ/顧客先メモ */}
        <AddMemoPopup 
          ref={this.addMemoPopup} 
          data={this.state.addMemoPopupData}
          positive={true}
          {...this.state.singleData}
          updateMemo = {(data, isOrderMemo) => {this.updateEstimateMemo(data, isOrderMemo)}}
        />

        {/** #1873 警告バナー対応 */}

        <Modal isOpen={this.state.pdf_regist_modal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=>{this.togglePdfRegistModal(undefined)}}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">アクセス許可確認</h5>
          </div>
          <ModalBody style={{textAlign:"center"}}>
            <p>アクセス許可後にPDFを作成してください。</p><br />
            <Button 
              color="info" 
              style={{minWidth:"200px"}}
              onClick={() => { 
                this.state.Pdf01final && this.state.Pdf01final.length>0 && this.state.Pdf01final.forEach((pdf01result)=>{
                  pdf01result.forEach(item => {
                    if (item){
                      const {
                        spreadsheet_id
                      } = item
                      spreadsheet_id&&window.open(`https://docs.google.com/spreadsheets/d/${spreadsheet_id}`)
                    }
                  })
                })
              }}>
              見積書を確認
            </Button>
            &nbsp;&nbsp;&nbsp;
             <Button 
              color="info" 
              style={{minWidth:"200px"}}
              onClick={() => { 
                this.state.Pdf02final && window.open(`https://docs.google.com/spreadsheets/d/${this.state.Pdf02final.spreadsheet_id}`)
                this.setState({
                  pdf_created: true
                });
              }}>
              経路図を確認
            </Button><br />
            <Button 
              color="info" 
              style={{minWidth:"200px"}}
              disabled={!this.state.pdf_created}
              onClick={() => { 
                this.pdfCreate()
              }}>
              PDF作成
            </Button><br />
            <Button 
              color="info" 
              style={{minWidth:"200px"}}
              disabled={!this.state.pdf_registed}
              onClick={() => { 
                this.setState({
                  pdf_registed: false
                });
                this.togglePdfRegistModal(undefined);
                // console.log(this.state.estimate_regist_flg)
                if(this.state.estimate_regist_flg === true){
                  this.regEstimateData();
                }
              }}>
              完了
            </Button>
          </ModalBody>
        </Modal>


        <div id="googlemap" style={{display:'none'}}>
            <div id="map"></div>
        </div>
      </>
    );

  }

  // 顧客用メモ,仕入先メモ表示用
  memoPopupAction = (isOrderMemo) => {
    //更新の場合はpopupを表示
    this.setState({
      addMemoPopupData : {
        values : this.state.singleData.values,
        isOrderMemo: isOrderMemo,
        label: isOrderMemo?"顧客メモ":"仕入先メモ",
      }
    }, () => { this.addMemoPopup.current.show() })
  }

  // メモ更新
  updateEstimateMemo(data, isOrderMemo){
    //編集の場合
    if (this.isEdit()){
      const url = '/api/estimate/memo/' + this.state.singleData.values.ESTIMATE__ulid
      const params = {
        add_memo: data.add_memo,
        isOrderMemo: isOrderMemo,
        update_timestamp: this.state.singleData.values.ESTIMATE__update_timestamp,
        login_user: localStorage.getItem("name")
      }
      Request.patch(url, params, (res)=>{
        this.state.singleData.values.order_memo = res.Data.order_memo
        this.state.singleData.values.supplier_memo = res.Data.supplier_memo
        this.state.singleData.values.ESTIMATE__update_timestamp = res.Data.update_timestamp

        const singleData = this.state.singleData;
        this.setState({
          singleData:{
            ...singleData,
          }
        })
      })
    } else {
      if (isOrderMemo) {
        this.state.singleData.values.order_memo = data.add_memo
      } else {
        this.state.singleData.values.supplier_memo = data.add_memo
      }
      const singleData = this.state.singleData;
      this.setState({
        singleData:{
          ...singleData,
        }
      })
    }

    // console.log(this.state.singleData)
  }

  renderSendSetting () {
    //console.log("renderSendSetting",this.state.notification);
    const {
      undefined_email,
      subcon_undefined_email,
      send_setting,
      subcon_send_setting,
    } = this.state.notification
    return (<>
      <Col md="8">
          <CardHeader>
            <CardTitle tag="h4" className="float-left">連絡先情報</CardTitle>
          </CardHeader>
      </Col>
      <Col md="12" className="detail">
        <Table>
          <tbody>
          <tr>
              <CustomTd label='CCメールアドレス'
                  colSpan="4"
                  name='NOTIFICATION__cc_email'
                  copy={false}
                  rootData={this.state.notification}
                  value={
                    <InputText
//                      default={cc_email}
                      validateCallback={this.validateSendContact} 
                      validateType='regist'
                      disabled={!send_setting || undefined_email}
                      />
                  }
              />
            </tr>
            <tr>
              <CustomTd label='FAX番号'
                  colSpan="4"
                  name='NOTIFICATION__fax'
                  copy={false}
                  rootData={this.state.notification}
                  // error={(this.validNotificateStatus(false,true,false) === false)? [GetMessage(["2024"])]:null}
                  value={
                    <InputText
//                      default={fax}
                      validateCallback={this.validateSendContact} 
                      validateType='regist'
                      disabled={!send_setting}
                      />
                  }
              />
            </tr>
            <tr>
              <CustomTd label='案内方法'
                  colSpan="4"
                  name='NOTIFICATION__guide_type'
                  copy={false}
                  rootData={this.state.notification}
                  value={
                    <InputRadio
                      disabled={!send_setting || undefined_email}
                      options={
                        [
                          {
                              default : this.state.notification.values.guide_type,
                              label : "両方",
                              value : 0,
                          },
                          {
                            label : "Eメール案内希望",
                            value : 1
                          },
                          {
                            label : "FAX案内希望",
                            value : 2,
                          },
                        ]
                      }
                      validateCallback={this.validateSendContact} 
                      validateType='regist'
                  />
                  }
              />
            </tr>
            <tr>
              <CustomTd label='CCメールアドレス
              （下請）'
                  colSpan="4"
                  name='NOTIFICATION__subcon_cc_email'
                  copy={false}
                  rootData={this.state.notification}
                  value={
                    <InputText
//                      default={subcon_cc_email}
                      validateCallback={this.validateSendContact} 
                      validateType='regist'
                      disabled={!subcon_send_setting || subcon_undefined_email}
                      />
                  }
              />
            </tr>
            <tr>
              <CustomTd label='FAX番号
              （下請）'
                  colSpan="4"
                  name='NOTIFICATION__subcon_fax'
                  copy={false}
                  rootData={this.state.notification}
                  // error={(this.validNotificateStatus(false,false,true) === false)?[GetMessage(["2024"])]:null}
                  value={
                    <InputText
//                      default={subcon_fax}
                      validateCallback={this.validateSendContact} 
                      validateType='regist'
                      disabled={!subcon_send_setting}
                      />
                  }
              />
            </tr>
            <tr>
              <CustomTd label='案内方法
              （下請）'
                  colSpan="4"
                  name='NOTIFICATION__subcon_guide_type'
                  copy={false}
                  rootData={this.state.notification}
                  value={
                    <InputRadio
                      disabled={!subcon_send_setting || subcon_undefined_email}
                      options={
                        [
                          {
                            default : this.state.notification.values.subcon_guide_type,
                            label : "両方",
                            value : 0,
                          },
                          {
                            label : "Eメール案内希望",
                            value : 1,
                          },
                          {
                            label : "FAX案内希望",
                            value : 2,
                          },
                        ]
                      }
                    validateCallback={this.validateSendContact} 
                    validateType='regist'
                  />
                  }
                />
              </tr>
          </tbody>
        </Table>
      </Col>
    </>);
  }

    // 見積作成処理(データ作成/モーダル表示)
    async onClickedSaveEstimates () {
      // 全ての見積の情報を入力したか確認
      //見積件数
      if (this.state.copyRouteMapFlag == false) {
        const estimateCount = Object.keys(this.state.data);
        if(estimateCount.length > this.state.doneEstimate.length){
          this.props.alertModal.current.showErrorModal({messageNo:2493})
          return;
        }
      }
      // ページのvalidatite
      if(this.validate()){
        if ( this.validNotificateStatus() === false ) {
          let message = getErrorCodes(this.state.notification.errors)
          if(message.length > 0){
            this.props.alertModal.current.showErrorModal({messageNo:message})
            return false
          }
          this.props.alertModal.current.showErrorModal({messageNo:"2024",message:message});
          return false;
        }
        // ToDo微妙
        // すでにroutemapが登録ずみであれば、登録モーダルを表示する
        if (this.state.syncMapParamters || this.state.copyRouteMapFlag===true) {
          this.sendEstimates()
          return
        }
    
        let uploadData = await this.createRouteMaps()
        if(uploadData == false){
          this.props.alertModal.current.showErrorModal({
            messageNo:2508 
          }, ()=>{
          })        
  
          return ;
        }
    
        let {data} = this.state
        let {values} = this.state.singleData
  
        Object.values(uploadData).forEach((newData)=>{
          if (values.keyForRequestParking == newData.keyForRequestParking) {
            values = {
              ...values,
              survey_route_picture_url:newData.survey_route_picture_url,
              ESTIMATE__survey_route_picture_url:newData.ESTIMATE__survey_route_picture_url,
              survey_route_zoom_picture_url: newData.survey_route_zoom_picture_url,
              ESTIMATE__survey_route_zoom_picture_url: newData.ESTIMATE__survey_route_zoom_picture_url,
              survey_route_qr_url: newData.survey_route_qr_url,
              survey_route_zoom_qr_url: newData.survey_route_zoom_qr_url,
              ESTIMATE__survey_route_qr_url: newData.ESTIMATE__survey_route_qr_url,
              ESTIMATE__survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
            };
          }
          data[newData.keyForRequestParking] = {
            ...data[newData.keyForRequestParking],
            survey_route_picture_url:newData.survey_route_picture_url,
            ESTIMATE__survey_route_picture_url:newData.ESTIMATE__survey_route_picture_url,
            survey_route_zoom_picture_url: newData.survey_route_zoom_picture_url,
            ESTIMATE__survey_route_zoom_picture_url: newData.ESTIMATE__survey_route_zoom_picture_url,
            survey_route_qr_url: newData.survey_route_qr_url,
            survey_route_zoom_qr_url: newData.survey_route_zoom_qr_url,
            ESTIMATE__survey_route_qr_url: newData.ESTIMATE__survey_route_qr_url,
            ESTIMATE__survey_route_zoom_qr_url: newData.ESTIMATE__survey_route_zoom_qr_url,
          }
        })
  
        this.setState({
          data: data,
          singleData: {
            ...this.state.singleData,
            values: values
          },
          syncMapParamters : true
        },()=>{
          this.toggleRegistModal()
        })
      }
    }


  //見積を作成
  async regist() {
    if (this.validate()) {
      try {
        const useCustomerSystem = this.state.singleData.values.customer_system_use_flag === 1 ? true : false;
        
        Request.setProgress(10, undefined, GetMessage(2436))
        
        const{
          want_guide_type,
          want_guide_type_subcontract,
        } = this.state.request_data
          
        let dataList = this.validateEstimateDetails(this.getStateToDataForm())

        //　警告バナー対応 見積登録前の確認
        const keys = Object.keys(dataList);
        keys.forEach(key => {
          dataList[key]["estimate_pdf_check"] = true
        })
        // console.log(dataList)
        const {
          Pdf01final,
          Pdf02final
        } = await this.getPdf1and2(dataList, `見積作成中`)

        // TODO なにしてる
        const failedPdf01 = Pdf01final && Pdf01final.length && Pdf01final[0] && Pdf01final[0].length ?
          await Pdf01final[0].findIndex(result => (result&&result.spreadsheet_id)===undefined) : 0

        // PDF作成失敗
        if(failedPdf01 > -1){
          Request.setProgress(0)
          return
        }

        (failedPdf01 < 0) && Request.setProgress(30, `見積作成中`, GetMessage(2436))
        if (!Pdf02final){
          Request.setProgress(0)
          return
        }

        Pdf02final && Request.setProgress(40, `見積作成中`, GetMessage(2436))

        this.setState({
          Pdf01final: Pdf01final,
          Pdf02final: Pdf02final
        });

        Request.setProgress(0)
        {/** #1873 警告バナー対応 */}
        this.togglePdfRegistModal(false);


      } catch (error) {
        Request.setProgress(0)
        console.log(error)
        this.props.alertModal.current.showErrorModal({
          messageNo: 2402
        })
      }
    }
  }

  async regEstimateData(){
    try {
        const {dataList,Pdf02final,Pdf01final} = this.state;
        //PDF情報をデータリストに追加
        const dataListWithPdfMap = Object.keys(dataList).reduce((acc, ulid, index)=>{
          const estimate = dataList[ulid]
          const ESTIMATE__latest_pdf_survey_url = Pdf01final&&Pdf01final[index]&&Pdf01final[index].map(item => {
            return item.file_id
          }).join(',')
          acc[ulid] = {
            ...estimate,
            latest_pdf_route_url : Pdf02final&&Pdf02final.spreadsheet_id,
            latest_pdf_route_file_id : Pdf02final&&Pdf02final.file_id,
            latest_pdf_survey_url: Pdf01final&&Pdf01final[index]&&Pdf01final[index][0]&&Pdf01final[index][0].spreadsheet_id,
            latest_pdf_survey_file_id : Pdf01final&&Pdf01final[index]&&Pdf01final[index][0]&&Pdf01final[index][0].file_id,
            ESTIMATE__latest_pdf_route_url : Pdf02final&&Pdf02final.file_id, 
            ESTIMATE__latest_pdf_survey_url : ESTIMATE__latest_pdf_survey_url,
            survey_month_qty : estimate._CAL_month_qty,
            survey_day_qty : estimate._CAL_day_qty,
            cu_file : Pdf01final[index][0].cu_file,
            estimate_expire_date : this.state.singleData.values.estimate_expire_date || null,
            option_file : ESTIMATE__latest_pdf_survey_url.split(',')[1] ? ESTIMATE__latest_pdf_survey_url.split(',')[1] : "",
            option_column : this.customerUseCustomizedEstimateForTouken==estimate.customer_natural_id ? "contract_pdf_url" : "inhouse1_pdf_url"
          }
          return acc
        },{})

        const firstEstimateData = dataListWithPdfMap[Object.keys(dataListWithPdfMap)[0]]
        const estimateCommonParams = firstEstimateData.estimateCommonParams

        const {
          PROJECT__send_destination_type,
        } = estimateCommonParams.object_project

        Pdf02final && Request.setProgress(70, `見積データ更新中`)
        
        Request.setProgress(80, `見積データ更新中`)

        const finalResCode = await new Promise((resolve, reject)=>{
          const url = domain + '/api/estimate';

          // map objectからメモ情報とQR情報を生成
          let json_memo = ""
          if ( this.state.copyRouteMapFlag ) {
            json_memo = this.state.request_data.route_map_memo
          }
          else {
            let contents = {}
            this.state.mapObjects.forEach((obj,mapIndex)=>{
              contents = {
                ...contents,
                [mapIndex] : []
              }
              obj.objects.memos.forEach ((m)=>{
                contents[mapIndex].push(m.memo.contents)
              })
            })
            json_memo = JSON.stringify(contents)
          }

          let {
            subcon_send_setting
          }=this.state.notification

          let cc_email_subcontract = subcon_send_setting? this.state.notification.values.subcon_cc_email: ""
          let fax_subcontract = subcon_send_setting? this.state.notification.values.subcon_fax: ""

          const param = {
            ...dataListWithPdfMap,
            cu_file:this.state.cu_file,
            request_data: {
              send_destination_type: PROJECT__send_destination_type,
              request_update_timestamp: this.state.request_data.update_timestamp,
              request_id: this.state.request_data.id,
              web_survey_account : this.state.survey_data.values.web_survey_account,
              onsite_survey_account : this.state.survey_data.values.onsite_survey_account,
              // survey_estimate_status : this.state.survey_data.values.survey_estimate_status? this.state.survey_data.values.survey_estimate_status: 1,//Web調査,
              survey_estimate_status : 1,//Web調査,
              cc_email : this.state.notification.values.cc_email,
              fax : this.state.notification.values.fax,
              cc_email_subcontract : cc_email_subcontract,
              fax_subcontract : fax_subcontract,
              route_map_memo : json_memo, //
              auto_order_execution_flag: this.state.request_data.values.auto_order_execution_flag
            }
          }

          // 新規であればこれ、更新であればpatch
          !this.isEdit() ? 
          // 見積作成
          Request.post(url, param, res => {
            resolve(res.Code)
          },
          err=>{
            console.log('finalResCode err', err)
            reject(err)
          })
          : // 見積更新
          Request.patch(url, param, res => {
            resolve(res.Code)
          },
          err=>{
            console.log('finalResCode err', err)
            reject(err)
          })

        })
          
        if (finalResCode == 200){
          // Pdf01final.forEach((result)=>{
          //   result.forEach(item => {
          //     //download
          //     const {
          //       download_url
          //     } = item
          //     download_url&&window.open(download_url)
          //   })
          // })
          // Pdf02final.download_url&&window.open(Pdf02final.download_url)
          this.props.pageChangeAlert.current.inactivate();
          // TODO:　遷移先はどこかなー
          this.props.alertModal.current.confirmCheck({
            title: "処理完了",
            messageNo: [2417],
            closeBtn: false
          }, ()=>this.props.history.push(`/survey/check_waiting`), false) //見積もり編集の場合
        }
        Request.setProgress(0)
    } catch (error) {
      Request.setProgress(0)
      console.log(error)
      this.props.alertModal.current.showErrorModal({
        messageNo: 2402
      })
    }
  }
}


export default List;
